"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4556],{

/***/ 77702:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "gH": function() { return /* reexport */ footer_Footer1; }
});

// UNUSED EXPORTS: Footer10, Footer11, Footer12, Footer13, Footer14, Footer15, Footer16, Footer17, Footer18, Footer2, Footer3, Footer4, Footer5, Footer6, Footer7, Footer8, Footer9

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./src/components/reuseable/links/NavItemsWithHomeLink.tsx
var NavItemsWithHomeLink = __webpack_require__(55619);
// EXTERNAL MODULE: ./src/data/keywords.ts
var keywords = __webpack_require__(74870);
;// CONCATENATED MODULE: ./src/components/reuseable/links/PortfolioItems.tsx



// =========================================================
var PortfolioItems = function(param) {
    var placement = param.placement;
    var localLength = keywords.LocalSEOArrays.length;
    var internationalLength = keywords.InternationalSEOArrays.length;
    {
        placement === "footer" ? localLength = 5 : localLength = keywords.LocalSEOArrays.length;
    }
    {
        placement === "footer" ? internationalLength = 1 : internationalLength = keywords.LocalSEOArrays.length;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            keywords.LocalSEOArrays.slice(0, localLength).map(function(param) {
                var item = param.item, title = param.title;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                    className: "col",
                    style: {
                        cursor: "pointer"
                    },
                    title: title,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        //legacyBehavior2 passHref2
                        href: "/" + keywords.LocalSEOArrays[item].keywords[0].url + "/" + keywords.LocalSEOArrays[item].keywords[0].title.toLowerCase().replace(/ /g, "-"),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "dropdown-item",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    alt: keywords.LocalSEOArrays[item].keywords[1].title,
                                    src: "/img/clients/" + keywords.LocalSEOArrays[item].keywords[1].title.toLowerCase().replace(/ /g, "-") + ".jpg",
                                    // srcSet={`${image}@2x.jpg 2x`}
                                    className: "rounded lift d-block w-25 mw-100"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "d-lg-none fs-12",
                                    children: title
                                })
                            ]
                        })
                    })
                }, item);
            }),
            keywords.InternationalSEOArrays.slice(0, internationalLength).map(function(param) {
                var item = param.item, title = param.title;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                    className: "col",
                    title: title,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        //legacyBehavior2 passHref2
                        href: "/" + keywords.InternationalSEOArrays[item].keywords[0].url + "/" + keywords.InternationalSEOArrays[item].keywords[0].title.toLowerCase().replace(/ /g, "-"),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "dropdown-item",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    alt: keywords.InternationalSEOArrays[item].keywords[1].title,
                                    src: "/img/clients/" + keywords.InternationalSEOArrays[item].keywords[1].title.toLowerCase().replace(/ /g, "-") + ".jpg",
                                    // srcSet={`${image}@2x.jpg 2x`}
                                    className: "rounded lift d-block w-25 mw-100"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "d-lg-none fs-12",
                                    children: title
                                })
                            ]
                        })
                    })
                }, item);
            })
        ]
    });
};
/* harmony default export */ var links_PortfolioItems = (PortfolioItems);

// EXTERNAL MODULE: ./src/components/reuseable/links/DropdownToggleLink.tsx
var DropdownToggleLink = __webpack_require__(80533);
// EXTERNAL MODULE: ./src/components/reuseable/links/NextLink.tsx
var links_NextLink = __webpack_require__(99472);
;// CONCATENATED MODULE: ./src/components/reuseable/links/NavItemsServices.tsx




// =========================================================
var NavItemsServices = function(props, param) {
    var active = param.active;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
            className: "nav-item dropdown",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(DropdownToggleLink/* default */.Z, {
                    title: "Services"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                    className: "dropdown-menu mega-menu-dark",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            className: "nav-item dropdown",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "nav-link navlinkmtlg",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(links_NextLink/* default */.Z, {
                                    title: "CRO",
                                    href: "/" + keywords.CRO[0].url + "/" + keywords.CRO[0].title.toLowerCase().replace(/ /g, "-")
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            className: "nav-item dropdown",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "nav-link navlinkmtlg",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(links_NextLink/* default */.Z, {
                                    title: "Ecommerce SEO",
                                    href: "" + keywords.EcommerceSEO[0].url + "/" + keywords.EcommerceSEO[0].title.toLowerCase().replace(/ /g, "-")
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            className: "nav-item dropdown",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "nav-link navlinkmtlg",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(links_NextLink/* default */.Z, {
                                    title: "Google Analytics",
                                    href: "/" + keywords.GoogleAnalytics[0].url + "/" + keywords.GoogleAnalytics[0].title.toLowerCase().replace(/ /g, "-")
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            className: "nav-item dropdown",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "nav-link navlinkmtlg",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(links_NextLink/* default */.Z, {
                                    title: "SEO Audit",
                                    href: "/" + keywords.SEOAudit[0].url + "/" + keywords.SEOAudit[0].title.toLowerCase().replace(/ /g, "-")
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            className: "nav-item dropdown",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "nav-link navlinkmtlg",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(links_NextLink/* default */.Z, {
                                    title: "Pricing",
                                    href: "" + keywords.SEOPricing[0].url + "/" + keywords.SEOPricing[0].title.toLowerCase().replace(/ /g, "-")
                                })
                            })
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var links_NavItemsServices = (NavItemsServices);

;// CONCATENATED MODULE: ./src/components/blocks/footer/Footer1.tsx


// -------- data -------- // s



var Footer1 = function(param) {
    var email = param.email, phone = param.phone, address = param.address;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("footer", {
        className: "bg-navy text-inverse position-relative",
        style: {
            zIndex: 999
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "container pt-15 pt-md-17 pb-13 pb-md-15",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "d-lg-flex flex-row align-items-lg-center",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                        className: "display-4 mb-6 mb-lg-0 pe-lg-20 pe-xl-22 pe-xxl-25 text-white",
                        children: "Join Our Sucessful Clients By Using Our Services to grow your business."
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {
                    className: "mt-11 mb-12"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "row gy-6 gy-lg-0",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "col-md-4 col-lg-3",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "widget",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        className: "mb-4",
                                        src: "/img/logo/molto-seo-white.png",
                                        srcSet: "/img/logo/molto-seo-white.png 2x",
                                        alt: ""
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                        className: "mb-4",
                                        children: [
                                            "\xa9 2022 SEOptimist London. ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                            "All rights reserved."
                                        ]
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "col-md-4 col-lg-3",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "widget",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                        className: "widget-title text-white mb-3",
                                        children: "Get in Touch"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("address", {
                                        className: "pe-xl-15 pe-xxl-17",
                                        children: address
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        // legacyBehavior2 passHref2 
                                        href: "tel:".concat(phone),
                                        children: phone
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "col-md-4 col-lg-3",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "widget",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                        className: "widget-title text-white mb-3",
                                        children: "Menu"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                        className: "list-unstyled mb-0",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(NavItemsWithHomeLink/* default */.Z, {}),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(links_NavItemsServices, {
                                                placement: "header",
                                                active: "no"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                title: "Terms and Conditions",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                    // legacyBehavior2 passHref2 
                                                    href: "/terms",
                                                    children: "Terms and Conditions"
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "col-md-4 col-lg-3",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "widget",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                        className: "widget-title text-white mb-3 tablet",
                                        children: "Recent SEO"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                        className: "mb-0 nav-footer row row-cols-1 row-cols-lg-6 gx-0 gx-lg-2 gy-lg-2 list-unstyled",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(links_PortfolioItems, {
                                            placement: "footer"
                                        })
                                    })
                                ]
                            })
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var footer_Footer1 = (Footer1);

// EXTERNAL MODULE: ./src/components/reuseable/SocialLinks.tsx
var reuseable_SocialLinks = __webpack_require__(25970);
;// CONCATENATED MODULE: ./src/components/blocks/footer/Footer2.tsx


var Footer2 = function() {
    return /*#__PURE__*/ _jsxs("footer", {
        className: "bg-soft-primary",
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "container",
                children: /*#__PURE__*/ _jsx("div", {
                    className: "card shadow-lg mt-n16 mt-md-n21 mb-15 mb-md-14"
                })
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "container pb-12 text-center",
                children: /*#__PURE__*/ _jsx("div", {
                    className: "row mt-n10 mt-lg-0",
                    children: /*#__PURE__*/ _jsxs("div", {
                        className: "col-xl-10 mx-auto",
                        children: [
                            /*#__PURE__*/ _jsxs("div", {
                                className: "row mb-3",
                                children: [
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "col-md-4",
                                        children: /*#__PURE__*/ _jsxs("div", {
                                            className: "widget",
                                            children: [
                                                /*#__PURE__*/ _jsx("h4", {
                                                    className: "widget-title",
                                                    children: "Address"
                                                }),
                                                /*#__PURE__*/ _jsxs("address", {
                                                    children: [
                                                        "Moonshine St. 14/05 ",
                                                        /*#__PURE__*/ _jsx("br", {
                                                            className: "d-none d-md-block"
                                                        }),
                                                        " Light City, London, UK"
                                                    ]
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "col-md-4",
                                        children: /*#__PURE__*/ _jsxs("div", {
                                            className: "widget",
                                            children: [
                                                /*#__PURE__*/ _jsx("h4", {
                                                    className: "widget-title",
                                                    children: "Phone"
                                                }),
                                                /*#__PURE__*/ _jsxs("p", {
                                                    children: [
                                                        "+44 (0) 7441 397 020 ",
                                                        /*#__PURE__*/ _jsx("br", {}),
                                                        "00 (987) 654 32 10"
                                                    ]
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "col-md-4",
                                        children: /*#__PURE__*/ _jsxs("div", {
                                            className: "widget",
                                            children: [
                                                /*#__PURE__*/ _jsx("h4", {
                                                    className: "widget-title",
                                                    children: "E-mail"
                                                }),
                                                /*#__PURE__*/ _jsx("a", {
                                                    href: "mailto:james@seoptimist.co.uk",
                                                    className: "link-body",
                                                    children: "james@seoptimist.co.uk"
                                                }),
                                                /*#__PURE__*/ _jsx("br", {
                                                    className: "d-none d-md-block"
                                                }),
                                                /*#__PURE__*/ _jsx("a", {
                                                    href: "mailto:james@seoptimist.co.uk",
                                                    className: "link-body",
                                                    children: "james@seoptimist.co.uk"
                                                })
                                            ]
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsxs("p", {
                                children: [
                                    "\xa9 2022 SEOptimist London. ",
                                    /*#__PURE__*/ _jsx("br", {}),
                                    "All rights reserved."
                                ]
                            }),
                            /*#__PURE__*/ _jsx(SocialLinks, {
                                className: "nav social justify-content-center"
                            })
                        ]
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var footer_Footer2 = ((/* unused pure expression or super */ null && (Footer2)));

;// CONCATENATED MODULE: ./src/data/footer.ts
var footer_footerNav = [
    {
        id: 0,
        title: "About Us",
        url: "#"
    },
    {
        id: 1,
        title: "Our Story",
        url: "#"
    },
    {
        id: 2,
        title: "Projects",
        url: "#"
    },
    {
        id: 3,
        title: "Terms of Use",
        url: "#"
    },
    {
        id: 4,
        title: "Privacy Policy",
        url: "#"
    }
];
var footer_helps = [
    {
        id: 1,
        title: "Support",
        url: "#"
    },
    {
        id: 2,
        title: "Get Started",
        url: "#"
    },
    {
        id: 3,
        title: "Terms of Use",
        url: "#"
    },
    {
        id: 4,
        title: "Privacy Policy",
        url: "#"
    }
];
var footer_learnMore = [
    {
        id: 1,
        title: "About Us",
        url: "#"
    },
    {
        id: 2,
        title: "Our Story",
        url: "#"
    },
    {
        id: 3,
        title: "Projects",
        url: "#"
    },
    {
        id: 4,
        title: "Pricing",
        url: "#"
    },
    {
        id: 5,
        title: "Features",
        url: "#"
    }
];
var footer_tags = [
    {
        id: 1,
        title: "Still Life",
        url: "#"
    },
    {
        id: 2,
        title: "Urban",
        url: "#"
    },
    {
        id: 3,
        title: "Nature",
        url: "#"
    },
    {
        id: 4,
        title: "Landscape",
        url: "#"
    }
];
var footer_categories = [
    {
        id: 1,
        post: 21,
        title: "Lifestyle",
        url: "#"
    },
    {
        id: 2,
        post: 19,
        title: "Photography",
        url: "#"
    },
    {
        id: 3,
        post: 16,
        title: "Journal",
        url: "#"
    }
];
/* harmony default export */ var footer = ((/* unused pure expression or super */ null && (footer_footerNav)));

;// CONCATENATED MODULE: ./src/components/blocks/footer/Footer3.tsx



// -------- data -------- //

// =================================================
var Footer3 = function(param) {
    var hiddenNewsletter = param.hiddenNewsletter;
    // common links section
    var widget = function(list, title) {
        return /*#__PURE__*/ _jsxs("div", {
            className: "widget",
            children: [
                /*#__PURE__*/ _jsx("h4", {
                    className: "widget-title mb-3",
                    children: title
                }),
                /*#__PURE__*/ _jsx("ul", {
                    className: "list-unstyled text-reset mb-0",
                    children: list.map(function(param) {
                        var url = param.url, _$title = param.title, id = param.id;
                        return /*#__PURE__*/ _jsx("li", {
                            children: /*#__PURE__*/ _jsx(NextLink, {
                                href: url,
                                title: _$title
                            })
                        }, id);
                    })
                })
            ]
        });
    };
    return /*#__PURE__*/ _jsx("footer", {
        className: "bg-gradient-reverse-primary",
        children: /*#__PURE__*/ _jsxs("div", {
            className: "container pt-13 pt-md-15 pb-7",
            children: [
                !hiddenNewsletter && /*#__PURE__*/ _jsx("div", {
                    className: "card image-wrapper bg-full bg-image bg-overlay bg-overlay-400 mb-13",
                    style: {
                        backgroundImage: "url(/img/photos/bg2.jpg)"
                    },
                    children: /*#__PURE__*/ _jsx("div", {
                        className: "card-body p-9 p-xl-11",
                        children: /*#__PURE__*/ _jsxs("div", {
                            className: "row align-items-center gy-6",
                            children: [
                                /*#__PURE__*/ _jsxs("div", {
                                    className: "col-lg-7",
                                    children: [
                                        /*#__PURE__*/ _jsx("h3", {
                                            className: "display-5 text-white",
                                            children: "Subscribe to our newsletter"
                                        }),
                                        /*#__PURE__*/ _jsx("p", {
                                            className: "lead pe-lg-12 mb-0 text-white",
                                            children: "Subscribe to our newsletter to get our news & deals delivered to you. Dont worry, we hate spam and we respect your privacy."
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "col-lg-5 col-xl-4 offset-xl-1",
                                    children: /*#__PURE__*/ _jsx("div", {
                                        className: "newsletter-wrapper",
                                        children: /*#__PURE__*/ _jsx("div", {
                                            id: "mc_embed_signup2",
                                            children: /*#__PURE__*/ _jsx("form", {
                                                action: "https://elemisfreebies.us20.list-manage.com/subscribe/post?u=aa4947f70a475ce162057838d&id=b49ef47a9a",
                                                method: "post",
                                                id: "mc-embedded-subscribe-form2",
                                                name: "mc-embedded-subscribe-form",
                                                className: "validate dark-fields",
                                                target: "_blank",
                                                children: /*#__PURE__*/ _jsxs("div", {
                                                    id: "mc_embed_signup_scroll2",
                                                    children: [
                                                        /*#__PURE__*/ _jsxs("div", {
                                                            className: "mc-field-group input-group form-floating",
                                                            children: [
                                                                /*#__PURE__*/ _jsx("input", {
                                                                    type: "email",
                                                                    name: "EMAIL",
                                                                    id: "mce-EMAIL2",
                                                                    placeholder: "Email Address",
                                                                    className: "required email form-control"
                                                                }),
                                                                /*#__PURE__*/ _jsx("label", {
                                                                    htmlFor: "mce-EMAIL2",
                                                                    className: "position-absolute",
                                                                    children: "Email Address"
                                                                }),
                                                                /*#__PURE__*/ _jsx("input", {
                                                                    type: "submit",
                                                                    name: "subscribe",
                                                                    id: "mc-embedded-subscribe2",
                                                                    className: "btn btn-primary"
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ _jsxs("div", {
                                                            id: "mce-responses2",
                                                            className: "clear",
                                                            children: [
                                                                /*#__PURE__*/ _jsx("div", {
                                                                    className: "response",
                                                                    id: "mce-error-response2",
                                                                    style: {
                                                                        display: "none"
                                                                    }
                                                                }),
                                                                /*#__PURE__*/ _jsx("div", {
                                                                    className: "response",
                                                                    id: "mce-success-response2",
                                                                    style: {
                                                                        display: "none"
                                                                    }
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ _jsx("div", {
                                                            style: {
                                                                position: "absolute",
                                                                left: -5000
                                                            },
                                                            "aria-hidden": "true",
                                                            children: /*#__PURE__*/ _jsx("input", {
                                                                type: "text",
                                                                name: "b_ddc180777a163e0f9f66ee014_4b1bcfa0bc",
                                                                tabIndex: -1
                                                            })
                                                        }),
                                                        /*#__PURE__*/ _jsx("div", {
                                                            className: "clear"
                                                        })
                                                    ]
                                                })
                                            })
                                        })
                                    })
                                })
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: "row gy-6 gy-lg-0",
                    children: [
                        /*#__PURE__*/ _jsx("div", {
                            className: "col-lg-4",
                            children: /*#__PURE__*/ _jsxs("div", {
                                className: "widget",
                                children: [
                                    /*#__PURE__*/ _jsx("h3", {
                                        className: "h2 mb-3 ",
                                        children: "Join the Community"
                                    }),
                                    /*#__PURE__*/ _jsx("p", {
                                        className: "lead mb-5",
                                        children: "Lets make something great together. We are trusted by over 5000+ clients. Join them by using our services and grow your business."
                                    }),
                                    /*#__PURE__*/ _jsx(NextLink, {
                                        title: "Join Us",
                                        href: "#",
                                        className: "btn btn-primary rounded-pill"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "col-md-4 col-lg-2 offset-lg-2",
                            children: widget(helps, "Need Help?")
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "col-md-4 col-lg-2",
                            children: widget(learnMore, "Learn More")
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "col-md-4 col-lg-2",
                            children: /*#__PURE__*/ _jsxs("div", {
                                className: "widget",
                                children: [
                                    /*#__PURE__*/ _jsx("h4", {
                                        className: "widget-title mb-3",
                                        children: "Get in Touch"
                                    }),
                                    /*#__PURE__*/ _jsxs("address", {
                                        children: [
                                            "Address ",
                                            /*#__PURE__*/ _jsx("br", {}),
                                            "London"
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsx("a", {
                                        href: "mailto:james@seoptimist.co.uk",
                                        className: "link-body",
                                        children: "james@seoptimist.co.uk"
                                    }),
                                    /*#__PURE__*/ _jsx("br", {}),
                                    " +44 (0) 7441 397 020"
                                ]
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx("hr", {
                    className: "mt-13 mt-md-15 mb-7"
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: "d-md-flex align-items-center justify-content-between",
                    children: [
                        /*#__PURE__*/ _jsxs("p", {
                            className: "mb-2 mb-lg-0",
                            children: [
                                "\xa9 2022 SEOptimist London. ",
                                /*#__PURE__*/ _jsx("br", {}),
                                "All rights reserved."
                            ]
                        }),
                        /*#__PURE__*/ _jsx(SocialLinks, {
                            className: "nav social text-md-end"
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var footer_Footer3 = ((/* unused pure expression or super */ null && (Footer3)));

;// CONCATENATED MODULE: ./src/components/blocks/footer/Footer4.tsx

// -------- custom component -------- //


// -------- data -------- //

var Footer4 = function() {
    return /*#__PURE__*/ _jsx("footer", {
        className: "bg-light",
        children: /*#__PURE__*/ _jsx("div", {
            className: "container py-13 py-md-15",
            children: /*#__PURE__*/ _jsxs("div", {
                className: "row gy-6 gy-lg-0",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "col-md-4 col-lg-3",
                        children: /*#__PURE__*/ _jsxs("div", {
                            className: "widget",
                            children: [
                                /*#__PURE__*/ _jsx("img", {
                                    className: "mb-4",
                                    src: "/img/logo-dark.png",
                                    srcSet: "/img/logo-dark@2x.png 2x",
                                    alt: ""
                                }),
                                /*#__PURE__*/ _jsxs("p", {
                                    className: "mb-4",
                                    children: [
                                        "\xa9 2022 SEOptimist London. ",
                                        /*#__PURE__*/ _jsx("br", {}),
                                        "All rights reserved."
                                    ]
                                }),
                                /*#__PURE__*/ _jsx(SocialLinks, {
                                    className: "nav social"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "col-md-4 col-lg-3",
                        children: /*#__PURE__*/ _jsxs("div", {
                            className: "widget",
                            children: [
                                /*#__PURE__*/ _jsx("h4", {
                                    className: "widget-title mb-3",
                                    children: "Get in Touch"
                                }),
                                /*#__PURE__*/ _jsxs("address", {
                                    className: "pe-xl-15 pe-xxl-17",
                                    children: [
                                        "Address ",
                                        /*#__PURE__*/ _jsx("br", {}),
                                        "London"
                                    ]
                                }),
                                /*#__PURE__*/ _jsx(NextLink, {
                                    title: "james@seoptimist.co.uk",
                                    href: "mailto:#",
                                    className: "link-body"
                                }),
                                /*#__PURE__*/ _jsx("br", {}),
                                " +44 (0) 7441 397 020"
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "col-md-4 col-lg-3",
                        children: /*#__PURE__*/ _jsxs("div", {
                            className: "widget",
                            children: [
                                /*#__PURE__*/ _jsx("h4", {
                                    className: "widget-title mb-3",
                                    children: "Learn More"
                                }),
                                /*#__PURE__*/ _jsx("ul", {
                                    className: "list-unstyled text-reset mb-0",
                                    children: footerNav.map(function(param) {
                                        var title = param.title, url = param.url;
                                        return /*#__PURE__*/ _jsx("li", {
                                            children: /*#__PURE__*/ _jsx(NextLink, {
                                                title: title,
                                                href: url
                                            })
                                        }, title);
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "col-md-12 col-lg-3",
                        children: /*#__PURE__*/ _jsxs("div", {
                            className: "widget",
                            children: [
                                /*#__PURE__*/ _jsx("h4", {
                                    className: "widget-title mb-3",
                                    children: "Our Newsletter"
                                }),
                                /*#__PURE__*/ _jsx("p", {
                                    className: "mb-5",
                                    children: "Subscribe to our newsletter to get our news & deals delivered to you."
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "newsletter-wrapper",
                                    children: /*#__PURE__*/ _jsx("div", {
                                        id: "mc_embed_signup2",
                                        children: /*#__PURE__*/ _jsx("form", {
                                            method: "post",
                                            target: "_blank",
                                            className: "validate dark-fields",
                                            id: "mc-embedded-subscribe-form2",
                                            name: "mc-embedded-subscribe-form",
                                            action: "https://elemisfreebies.us20.list-manage.com/subscribe/post?u=aa4947f70a475ce162057838d&id=b49ef47a9a",
                                            children: /*#__PURE__*/ _jsxs("div", {
                                                id: "mc_embed_signup_scroll2",
                                                children: [
                                                    /*#__PURE__*/ _jsxs("div", {
                                                        className: "mc-field-group input-group form-floating",
                                                        children: [
                                                            /*#__PURE__*/ _jsx("input", {
                                                                type: "email",
                                                                name: "EMAIL",
                                                                id: "mce-EMAIL2",
                                                                placeholder: "Email Address",
                                                                className: "required email form-control"
                                                            }),
                                                            /*#__PURE__*/ _jsx("label", {
                                                                htmlFor: "mce-EMAIL2",
                                                                children: "Email Address"
                                                            }),
                                                            /*#__PURE__*/ _jsx("input", {
                                                                value: "Join",
                                                                type: "submit",
                                                                name: "subscribe",
                                                                id: "mc-embedded-subscribe2",
                                                                className: "btn btn-primary"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ _jsxs("div", {
                                                        id: "mce-responses2",
                                                        className: "clear",
                                                        children: [
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "response",
                                                                id: "mce-error-response2",
                                                                style: {
                                                                    display: "none"
                                                                }
                                                            }),
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "response",
                                                                id: "mce-success-response2",
                                                                style: {
                                                                    display: "none"
                                                                }
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ _jsx("div", {
                                                        style: {
                                                            position: "absolute",
                                                            left: "-5000px"
                                                        },
                                                        "aria-hidden": "true",
                                                        children: /*#__PURE__*/ _jsx("input", {
                                                            type: "text",
                                                            tabIndex: -1,
                                                            name: "b_ddc180777a163e0f9f66ee014_4b1bcfa0bc"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ _jsx("div", {
                                                        className: "clear"
                                                    })
                                                ]
                                            })
                                        })
                                    })
                                })
                            ]
                        })
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var footer_Footer4 = ((/* unused pure expression or super */ null && (Footer4)));

;// CONCATENATED MODULE: ./src/components/blocks/footer/Footer5.tsx

// -------- custom component -------- //


// -------- data -------- //

var Footer5 = function() {
    return /*#__PURE__*/ _jsx("footer", {
        className: "bg-dark text-inverse",
        children: /*#__PURE__*/ _jsx("div", {
            className: "container pt-15 pt-md-17 pb-13 pb-md-15",
            children: /*#__PURE__*/ _jsxs("div", {
                className: "row gy-6 gy-lg-0",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "col-md-4 col-lg-3",
                        children: /*#__PURE__*/ _jsxs("div", {
                            className: "widget",
                            children: [
                                /*#__PURE__*/ _jsx("img", {
                                    className: "mb-4",
                                    src: "/img/logo-light.png",
                                    srcSet: "/img/logo-light@2x.png 2x",
                                    alt: ""
                                }),
                                /*#__PURE__*/ _jsxs("p", {
                                    className: "mb-4",
                                    children: [
                                        "\xa9 2022 SEOptimist London. ",
                                        /*#__PURE__*/ _jsx("br", {}),
                                        "All rights reserved."
                                    ]
                                }),
                                /*#__PURE__*/ _jsx(SocialLinks, {
                                    className: "nav social social-white"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "col-md-4 col-lg-3",
                        children: /*#__PURE__*/ _jsxs("div", {
                            className: "widget",
                            children: [
                                /*#__PURE__*/ _jsx("h4", {
                                    className: "widget-title text-white mb-3",
                                    children: "Get in Touch"
                                }),
                                /*#__PURE__*/ _jsxs("address", {
                                    className: "pe-xl-15 pe-xxl-17",
                                    children: [
                                        "Address ",
                                        /*#__PURE__*/ _jsx("br", {}),
                                        "London"
                                    ]
                                }),
                                /*#__PURE__*/ _jsx(NextLink, {
                                    title: "james@seoptimist.co.uk",
                                    href: "mailto:#"
                                }),
                                /*#__PURE__*/ _jsx("br", {}),
                                " +44 (0) 7441 397 020"
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "col-md-4 col-lg-3",
                        children: /*#__PURE__*/ _jsxs("div", {
                            className: "widget",
                            children: [
                                /*#__PURE__*/ _jsx("h4", {
                                    className: "widget-title text-white mb-3",
                                    children: "Learn More"
                                }),
                                /*#__PURE__*/ _jsx("ul", {
                                    className: "list-unstyled mb-0",
                                    children: footerNav.map(function(param) {
                                        var title = param.title, url = param.url;
                                        return /*#__PURE__*/ _jsx("li", {
                                            children: /*#__PURE__*/ _jsx(NextLink, {
                                                title: title,
                                                href: url
                                            })
                                        }, title);
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "col-md-12 col-lg-3",
                        children: /*#__PURE__*/ _jsxs("div", {
                            className: "widget",
                            children: [
                                /*#__PURE__*/ _jsx("h4", {
                                    className: "widget-title text-white mb-3",
                                    children: "Our Newsletter"
                                }),
                                /*#__PURE__*/ _jsx("p", {
                                    className: "mb-5",
                                    children: "Subscribe to our newsletter to get our news & deals delivered to you."
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "newsletter-wrapper",
                                    children: /*#__PURE__*/ _jsx("div", {
                                        id: "mc_embed_signup2",
                                        children: /*#__PURE__*/ _jsx("form", {
                                            method: "post",
                                            target: "_blank",
                                            className: "validate dark-fields",
                                            id: "mc-embedded-subscribe-form2",
                                            name: "mc-embedded-subscribe-form",
                                            action: "https://elemisfreebies.us20.list-manage.com/subscribe/post?u=aa4947f70a475ce162057838d&id=b49ef47a9a",
                                            children: /*#__PURE__*/ _jsxs("div", {
                                                id: "mc_embed_signup_scroll2",
                                                children: [
                                                    /*#__PURE__*/ _jsxs("div", {
                                                        className: "mc-field-group input-group form-floating",
                                                        children: [
                                                            /*#__PURE__*/ _jsx("input", {
                                                                type: "email",
                                                                name: "EMAIL",
                                                                id: "mce-EMAIL2",
                                                                placeholder: "Email Address",
                                                                className: "required email form-control"
                                                            }),
                                                            /*#__PURE__*/ _jsx("label", {
                                                                htmlFor: "mce-EMAIL2",
                                                                children: "Email Address"
                                                            }),
                                                            /*#__PURE__*/ _jsx("input", {
                                                                value: "Join",
                                                                type: "submit",
                                                                name: "subscribe",
                                                                id: "mc-embedded-subscribe2",
                                                                className: "btn btn-primary"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ _jsxs("div", {
                                                        id: "mce-responses2",
                                                        className: "clear",
                                                        children: [
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "response",
                                                                id: "mce-error-response2",
                                                                style: {
                                                                    display: "none"
                                                                }
                                                            }),
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "response",
                                                                id: "mce-success-response2",
                                                                style: {
                                                                    display: "none"
                                                                }
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ _jsx("div", {
                                                        style: {
                                                            position: "absolute",
                                                            left: "-5000px"
                                                        },
                                                        "aria-hidden": "true",
                                                        children: /*#__PURE__*/ _jsx("input", {
                                                            type: "text",
                                                            tabIndex: -1,
                                                            name: "b_ddc180777a163e0f9f66ee014_4b1bcfa0bc"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ _jsx("div", {
                                                        className: "clear"
                                                    })
                                                ]
                                            })
                                        })
                                    })
                                })
                            ]
                        })
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var footer_Footer5 = ((/* unused pure expression or super */ null && (Footer5)));

;// CONCATENATED MODULE: ./src/components/blocks/footer/Footer6.tsx

// -------- custom component -------- //


// -------- data -------- //

var Footer6 = function() {
    return /*#__PURE__*/ _jsx("footer", {
        className: "bg-dark text-inverse mt-5 mt-md-16",
        children: /*#__PURE__*/ _jsx("div", {
            className: "container py-13 py-md-15",
            children: /*#__PURE__*/ _jsxs("div", {
                className: "row gy-6 gy-lg-0",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "col-md-4 col-lg-3",
                        children: /*#__PURE__*/ _jsxs("div", {
                            className: "widget",
                            children: [
                                /*#__PURE__*/ _jsx("img", {
                                    className: "mb-4",
                                    src: "/img/logo-light.png",
                                    srcSet: "/img/logo-light@2x.png 2x",
                                    alt: ""
                                }),
                                /*#__PURE__*/ _jsxs("p", {
                                    className: "mb-4",
                                    children: [
                                        "\xa9 2022 SEOptimist London. ",
                                        /*#__PURE__*/ _jsx("br", {}),
                                        "All rights reserved."
                                    ]
                                }),
                                /*#__PURE__*/ _jsx(SocialLinks, {
                                    className: "nav social social-white"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "col-md-4 col-lg-3",
                        children: /*#__PURE__*/ _jsxs("div", {
                            className: "widget",
                            children: [
                                /*#__PURE__*/ _jsx("h4", {
                                    className: "widget-title text-white mb-3",
                                    children: "Get in Touch"
                                }),
                                /*#__PURE__*/ _jsxs("address", {
                                    className: "pe-xl-15 pe-xxl-17",
                                    children: [
                                        "Address ",
                                        /*#__PURE__*/ _jsx("br", {}),
                                        "London"
                                    ]
                                }),
                                /*#__PURE__*/ _jsx(NextLink, {
                                    title: "james@seoptimist.co.uk",
                                    href: "mailto:#"
                                }),
                                /*#__PURE__*/ _jsx("br", {}),
                                " +44 (0) 7441 397 020"
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "col-md-4 col-lg-3",
                        children: /*#__PURE__*/ _jsxs("div", {
                            className: "widget",
                            children: [
                                /*#__PURE__*/ _jsx("h4", {
                                    className: "widget-title text-white mb-3",
                                    children: "Learn More"
                                }),
                                /*#__PURE__*/ _jsx("ul", {
                                    className: "list-unstyled mb-0",
                                    children: footerNav.map(function(param) {
                                        var title = param.title, url = param.url;
                                        return /*#__PURE__*/ _jsx("li", {
                                            children: /*#__PURE__*/ _jsx(NextLink, {
                                                title: title,
                                                href: url
                                            })
                                        }, title);
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "col-md-12 col-lg-3",
                        children: /*#__PURE__*/ _jsxs("div", {
                            className: "widget",
                            children: [
                                /*#__PURE__*/ _jsx("h4", {
                                    className: "widget-title text-white mb-3",
                                    children: "Our Newsletter"
                                }),
                                /*#__PURE__*/ _jsx("p", {
                                    className: "mb-5",
                                    children: "Subscribe to our newsletter to get our news & deals delivered to you."
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "newsletter-wrapper",
                                    children: /*#__PURE__*/ _jsx("div", {
                                        id: "mc_embed_signup2",
                                        children: /*#__PURE__*/ _jsx("form", {
                                            method: "post",
                                            target: "_blank",
                                            className: "validate dark-fields",
                                            id: "mc-embedded-subscribe-form2",
                                            name: "mc-embedded-subscribe-form",
                                            action: "https://elemisfreebies.us20.list-manage.com/subscribe/post?u=aa4947f70a475ce162057838d&id=b49ef47a9a",
                                            children: /*#__PURE__*/ _jsxs("div", {
                                                id: "mc_embed_signup_scroll2",
                                                children: [
                                                    /*#__PURE__*/ _jsxs("div", {
                                                        className: "mc-field-group input-group form-floating",
                                                        children: [
                                                            /*#__PURE__*/ _jsx("input", {
                                                                type: "email",
                                                                name: "EMAIL",
                                                                id: "mce-EMAIL2",
                                                                placeholder: "Email Address",
                                                                className: "required email form-control"
                                                            }),
                                                            /*#__PURE__*/ _jsx("label", {
                                                                htmlFor: "mce-EMAIL2",
                                                                children: "Email Address"
                                                            }),
                                                            /*#__PURE__*/ _jsx("input", {
                                                                value: "Join",
                                                                type: "submit",
                                                                name: "subscribe",
                                                                id: "mc-embedded-subscribe2",
                                                                className: "btn btn-primary"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ _jsxs("div", {
                                                        id: "mce-responses2",
                                                        className: "clear",
                                                        children: [
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "response",
                                                                id: "mce-error-response2",
                                                                style: {
                                                                    display: "none"
                                                                }
                                                            }),
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "response",
                                                                id: "mce-success-response2",
                                                                style: {
                                                                    display: "none"
                                                                }
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ _jsx("div", {
                                                        style: {
                                                            position: "absolute",
                                                            left: "-5000px"
                                                        },
                                                        "aria-hidden": "true",
                                                        children: /*#__PURE__*/ _jsx("input", {
                                                            type: "text",
                                                            tabIndex: -1,
                                                            name: "b_ddc180777a163e0f9f66ee014_4b1bcfa0bc"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ _jsx("div", {
                                                        className: "clear"
                                                    })
                                                ]
                                            })
                                        })
                                    })
                                })
                            ]
                        })
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var footer_Footer6 = ((/* unused pure expression or super */ null && (Footer6)));

;// CONCATENATED MODULE: ./src/components/blocks/footer/Footer7.tsx



// -------- data -------- //

// common links section
var widget = function(list, title) {
    return /*#__PURE__*/ _jsxs("div", {
        className: "widget",
        children: [
            /*#__PURE__*/ _jsx("h4", {
                className: "widget-title mb-3",
                children: title
            }),
            /*#__PURE__*/ _jsx("ul", {
                className: "list-unstyled text-reset mb-0",
                children: list.map(function(param) {
                    var url = param.url, _$title = param.title, id = param.id;
                    return /*#__PURE__*/ _jsx("li", {
                        children: /*#__PURE__*/ _jsx(NextLink, {
                            href: url,
                            title: _$title
                        })
                    }, id);
                })
            })
        ]
    });
};
var Footer7 = function() {
    return /*#__PURE__*/ _jsx("footer", {
        className: "bg-light",
        children: /*#__PURE__*/ _jsxs("div", {
            className: "container pt-14 pt-md-17 pb-7",
            children: [
                /*#__PURE__*/ _jsxs("div", {
                    className: "row gy-6 gy-lg-0",
                    children: [
                        /*#__PURE__*/ _jsx("div", {
                            className: "col-lg-4",
                            children: /*#__PURE__*/ _jsxs("div", {
                                className: "widget",
                                children: [
                                    /*#__PURE__*/ _jsx("h3", {
                                        className: "h2 mb-3 ",
                                        children: "Join the Community"
                                    }),
                                    /*#__PURE__*/ _jsx("p", {
                                        className: "lead mb-5",
                                        children: "Lets make something great together. We are trusted by over 5000+ clients. Join them by using our services and grow your business."
                                    }),
                                    /*#__PURE__*/ _jsx(NextLink, {
                                        title: "Join Us",
                                        href: "#",
                                        className: "btn btn-primary rounded-pill"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "col-md-4 col-lg-2 offset-lg-2",
                            children: widget(helps, "Need Help?")
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "col-md-4 col-lg-2",
                            children: widget(learnMore, "Learn More")
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "col-md-4 col-lg-2",
                            children: /*#__PURE__*/ _jsxs("div", {
                                className: "widget",
                                children: [
                                    /*#__PURE__*/ _jsx("h4", {
                                        className: "widget-title mb-3",
                                        children: "Get in Touch"
                                    }),
                                    /*#__PURE__*/ _jsxs("address", {
                                        children: [
                                            "Address ",
                                            /*#__PURE__*/ _jsx("br", {}),
                                            "London"
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsx("a", {
                                        href: "mailto:james@seoptimist.co.uk",
                                        className: "link-body",
                                        children: "james@seoptimist.co.uk"
                                    }),
                                    /*#__PURE__*/ _jsx("br", {}),
                                    " +44 (0) 7441 397 020"
                                ]
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx("hr", {
                    className: "mt-13 mt-md-15 mb-7"
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: "d-md-flex align-items-center justify-content-between",
                    children: [
                        /*#__PURE__*/ _jsxs("p", {
                            className: "mb-2 mb-lg-0",
                            children: [
                                "\xa9 2022 SEOptimist London. ",
                                /*#__PURE__*/ _jsx("br", {}),
                                "All rights reserved."
                            ]
                        }),
                        /*#__PURE__*/ _jsx(SocialLinks, {
                            className: "nav social text-md-end"
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var footer_Footer7 = ((/* unused pure expression or super */ null && (Footer7)));

;// CONCATENATED MODULE: ./src/components/blocks/footer/Footer8.tsx

// -------- custom component -------- //


// -------- data -------- //

var Footer8 = function() {
    return /*#__PURE__*/ _jsx("footer", {
        className: "bg-dark text-inverse",
        children: /*#__PURE__*/ _jsx("div", {
            className: "container py-13 py-md-15",
            children: /*#__PURE__*/ _jsxs("div", {
                className: "row gy-6 gy-lg-0",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "col-md-4 col-lg-3",
                        children: /*#__PURE__*/ _jsxs("div", {
                            className: "widget",
                            children: [
                                /*#__PURE__*/ _jsx("img", {
                                    className: "mb-4",
                                    src: "/img/logo-light.png",
                                    srcSet: "/img/logo-light@2x.png 2x",
                                    alt: ""
                                }),
                                /*#__PURE__*/ _jsxs("p", {
                                    className: "mb-4",
                                    children: [
                                        "\xa9 2022 SEOptimist London. ",
                                        /*#__PURE__*/ _jsx("br", {}),
                                        "All rights reserved."
                                    ]
                                }),
                                /*#__PURE__*/ _jsx(SocialLinks, {
                                    className: "nav social social-white"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "col-md-4 col-lg-3",
                        children: /*#__PURE__*/ _jsxs("div", {
                            className: "widget",
                            children: [
                                /*#__PURE__*/ _jsx("h4", {
                                    className: "widget-title text-white mb-3",
                                    children: "Get in Touch"
                                }),
                                /*#__PURE__*/ _jsxs("address", {
                                    className: "pe-xl-15 pe-xxl-17",
                                    children: [
                                        "Address ",
                                        /*#__PURE__*/ _jsx("br", {}),
                                        "London"
                                    ]
                                }),
                                /*#__PURE__*/ _jsx(NextLink, {
                                    title: "james@seoptimist.co.uk",
                                    href: "mailto:#"
                                }),
                                /*#__PURE__*/ _jsx("br", {}),
                                " +44 (0) 7441 397 020"
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "col-md-4 col-lg-3",
                        children: /*#__PURE__*/ _jsxs("div", {
                            className: "widget",
                            children: [
                                /*#__PURE__*/ _jsx("h4", {
                                    className: "widget-title text-white mb-3",
                                    children: "Learn More"
                                }),
                                /*#__PURE__*/ _jsx("ul", {
                                    className: "list-unstyled mb-0",
                                    children: footerNav.map(function(param) {
                                        var title = param.title, url = param.url;
                                        return /*#__PURE__*/ _jsx("li", {
                                            children: /*#__PURE__*/ _jsx(NextLink, {
                                                title: title,
                                                href: url
                                            })
                                        }, title);
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "col-md-12 col-lg-3",
                        children: /*#__PURE__*/ _jsxs("div", {
                            className: "widget",
                            children: [
                                /*#__PURE__*/ _jsx("h4", {
                                    className: "widget-title text-white mb-3",
                                    children: "Our Newsletter"
                                }),
                                /*#__PURE__*/ _jsx("p", {
                                    className: "mb-5",
                                    children: "Subscribe to our newsletter to get our news & deals delivered to you."
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "newsletter-wrapper",
                                    children: /*#__PURE__*/ _jsx("div", {
                                        id: "mc_embed_signup2",
                                        children: /*#__PURE__*/ _jsx("form", {
                                            method: "post",
                                            target: "_blank",
                                            className: "validate dark-fields",
                                            id: "mc-embedded-subscribe-form2",
                                            name: "mc-embedded-subscribe-form",
                                            action: "https://elemisfreebies.us20.list-manage.com/subscribe/post?u=aa4947f70a475ce162057838d&id=b49ef47a9a",
                                            children: /*#__PURE__*/ _jsxs("div", {
                                                id: "mc_embed_signup_scroll2",
                                                children: [
                                                    /*#__PURE__*/ _jsxs("div", {
                                                        className: "mc-field-group input-group form-floating",
                                                        children: [
                                                            /*#__PURE__*/ _jsx("input", {
                                                                type: "email",
                                                                name: "EMAIL",
                                                                id: "mce-EMAIL2",
                                                                placeholder: "Email Address",
                                                                className: "required email form-control"
                                                            }),
                                                            /*#__PURE__*/ _jsx("label", {
                                                                htmlFor: "mce-EMAIL2",
                                                                children: "Email Address"
                                                            }),
                                                            /*#__PURE__*/ _jsx("input", {
                                                                value: "Join",
                                                                type: "submit",
                                                                name: "subscribe",
                                                                id: "mc-embedded-subscribe2",
                                                                className: "btn btn-primary"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ _jsxs("div", {
                                                        id: "mce-responses2",
                                                        className: "clear",
                                                        children: [
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "response",
                                                                id: "mce-error-response2",
                                                                style: {
                                                                    display: "none"
                                                                }
                                                            }),
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "response",
                                                                id: "mce-success-response2",
                                                                style: {
                                                                    display: "none"
                                                                }
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ _jsx("div", {
                                                        style: {
                                                            position: "absolute",
                                                            left: "-5000px"
                                                        },
                                                        "aria-hidden": "true",
                                                        children: /*#__PURE__*/ _jsx("input", {
                                                            type: "text",
                                                            tabIndex: -1,
                                                            name: "b_ddc180777a163e0f9f66ee014_4b1bcfa0bc"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ _jsx("div", {
                                                        className: "clear"
                                                    })
                                                ]
                                            })
                                        })
                                    })
                                })
                            ]
                        })
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var footer_Footer8 = ((/* unused pure expression or super */ null && (Footer8)));

;// CONCATENATED MODULE: ./src/components/blocks/footer/Footer9.tsx

// -------- custom component -------- //


// -------- data -------- //

var Footer9 = function() {
    return /*#__PURE__*/ _jsx("footer", {
        className: "bg-dark text-inverse",
        children: /*#__PURE__*/ _jsx("div", {
            className: "container py-13 py-md-15",
            children: /*#__PURE__*/ _jsxs("div", {
                className: "row gy-6 gy-lg-0",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "col-lg-4",
                        children: /*#__PURE__*/ _jsxs("div", {
                            className: "widget",
                            children: [
                                /*#__PURE__*/ _jsx("img", {
                                    className: "mb-4",
                                    src: "/img/logo-light.png",
                                    srcSet: "/img/logo-light@2x.png 2x",
                                    alt: ""
                                }),
                                /*#__PURE__*/ _jsxs("p", {
                                    className: "mb-4",
                                    children: [
                                        "\xa9 2022 SEOptimist London. ",
                                        /*#__PURE__*/ _jsx("br", {}),
                                        "All rights reserved."
                                    ]
                                }),
                                /*#__PURE__*/ _jsx(SocialLinks, {
                                    className: "nav social social-white"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "col-md-4 col-lg-2 offset-lg-2",
                        children: /*#__PURE__*/ _jsxs("div", {
                            className: "widget",
                            children: [
                                /*#__PURE__*/ _jsx("h4", {
                                    className: "widget-title mb-3 text-white",
                                    children: "Need Help?"
                                }),
                                /*#__PURE__*/ _jsx("ul", {
                                    className: "list-unstyled mb-0",
                                    children: helps.map(function(param) {
                                        var title = param.title, url = param.url;
                                        return /*#__PURE__*/ _jsx("li", {
                                            children: /*#__PURE__*/ _jsx(NextLink, {
                                                title: title,
                                                href: url
                                            })
                                        }, title);
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "col-md-4 col-lg-2",
                        children: /*#__PURE__*/ _jsxs("div", {
                            className: "widget",
                            children: [
                                /*#__PURE__*/ _jsx("h4", {
                                    className: "widget-title text-white mb-3",
                                    children: "Learn More"
                                }),
                                /*#__PURE__*/ _jsx("ul", {
                                    className: "list-unstyled mb-0",
                                    children: footerNav.map(function(param) {
                                        var title = param.title, url = param.url;
                                        return /*#__PURE__*/ _jsx("li", {
                                            children: /*#__PURE__*/ _jsx(NextLink, {
                                                title: title,
                                                href: url
                                            })
                                        }, title);
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "col-md-4 col-lg-2",
                        children: /*#__PURE__*/ _jsxs("div", {
                            className: "widget",
                            children: [
                                /*#__PURE__*/ _jsx("h4", {
                                    className: "widget-title mb-3 text-white",
                                    children: "Get in Touch"
                                }),
                                /*#__PURE__*/ _jsxs("address", {
                                    children: [
                                        "Address ",
                                        /*#__PURE__*/ _jsx("br", {}),
                                        "London"
                                    ]
                                }),
                                /*#__PURE__*/ _jsx(NextLink, {
                                    title: "james@seoptimist.co.uk",
                                    href: "mailto:#"
                                }),
                                /*#__PURE__*/ _jsx("br", {}),
                                " +44 (0) 7441 397 020"
                            ]
                        })
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var footer_Footer9 = ((/* unused pure expression or super */ null && (Footer9)));

;// CONCATENATED MODULE: ./src/components/blocks/footer/Footer10.tsx



// -------- data -------- //

var Footer10 = function() {
    // common links section
    var widget = function(list, title) {
        return /*#__PURE__*/ _jsxs("div", {
            className: "widget",
            children: [
                /*#__PURE__*/ _jsx("h4", {
                    className: "widget-title text-white mb-3",
                    children: title
                }),
                /*#__PURE__*/ _jsx("ul", {
                    className: "list-unstyled text-reset mb-0",
                    children: list.map(function(param) {
                        var url = param.url, _$title = param.title, id = param.id;
                        return /*#__PURE__*/ _jsx("li", {
                            children: /*#__PURE__*/ _jsx(NextLink, {
                                href: url,
                                title: _$title
                            })
                        }, id);
                    })
                })
            ]
        });
    };
    return /*#__PURE__*/ _jsx("footer", {
        className: "bg-dark text-inverse",
        children: /*#__PURE__*/ _jsxs("div", {
            className: "container pt-20 pt-lg-21 pb-7",
            children: [
                /*#__PURE__*/ _jsxs("div", {
                    className: "row gy-6 gy-lg-0",
                    children: [
                        /*#__PURE__*/ _jsx("div", {
                            className: "col-lg-4",
                            children: /*#__PURE__*/ _jsxs("div", {
                                className: "widget",
                                children: [
                                    /*#__PURE__*/ _jsx("h3", {
                                        className: "h2 mb-3 text-white",
                                        children: "Join the Community"
                                    }),
                                    /*#__PURE__*/ _jsx("p", {
                                        className: "lead mb-5",
                                        children: "Lets make something great together. We are trusted by over 5000+ clients. Join them by using our services and grow your business."
                                    }),
                                    /*#__PURE__*/ _jsx(NextLink, {
                                        title: "Join Us",
                                        href: "#",
                                        className: "btn btn-white rounded-pill"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "col-md-4 col-lg-2 offset-lg-2",
                            children: widget(helps, "Need Help?")
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "col-md-4 col-lg-2",
                            children: widget(learnMore, "Learn More")
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "col-md-4 col-lg-2",
                            children: /*#__PURE__*/ _jsxs("div", {
                                className: "widget",
                                children: [
                                    /*#__PURE__*/ _jsx("h4", {
                                        className: "widget-title text-white mb-3",
                                        children: "Get in Touch"
                                    }),
                                    /*#__PURE__*/ _jsxs("address", {
                                        children: [
                                            "Address ",
                                            /*#__PURE__*/ _jsx("br", {}),
                                            "London"
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsx("a", {
                                        href: "mailto:james@seoptimist.co.uk",
                                        children: "james@seoptimist.co.uk"
                                    }),
                                    /*#__PURE__*/ _jsx("br", {}),
                                    " +44 (0) 7441 397 020"
                                ]
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx("hr", {
                    className: "mt-13 mt-md-15 mb-7"
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: "d-md-flex align-items-center justify-content-between",
                    children: [
                        /*#__PURE__*/ _jsxs("p", {
                            className: "mb-2 mb-lg-0",
                            children: [
                                "\xa9 2022 SEOptimist London. ",
                                /*#__PURE__*/ _jsx("br", {}),
                                "All rights reserved."
                            ]
                        }),
                        /*#__PURE__*/ _jsx(SocialLinks, {
                            className: "nav social social-white text-md-end"
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var footer_Footer10 = ((/* unused pure expression or super */ null && (Footer10)));

;// CONCATENATED MODULE: ./src/components/blocks/footer/Footer11.tsx

// -------- custom component -------- //


// -------- data -------- //

var Footer11 = function() {
    return /*#__PURE__*/ _jsx("footer", {
        className: "bg-light",
        children: /*#__PURE__*/ _jsx("div", {
            className: "container pb-13 pb-md-15",
            children: /*#__PURE__*/ _jsxs("div", {
                className: "row gy-6 gy-lg-0",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "col-md-4 col-lg-3",
                        children: /*#__PURE__*/ _jsxs("div", {
                            className: "widget",
                            children: [
                                /*#__PURE__*/ _jsx("img", {
                                    className: "mb-4",
                                    src: "/img/logo-dark.png",
                                    srcSet: "/img/logo-dark@2x.png 2x",
                                    alt: ""
                                }),
                                /*#__PURE__*/ _jsxs("p", {
                                    className: "mb-4",
                                    children: [
                                        "\xa9 2022 SEOptimist London. ",
                                        /*#__PURE__*/ _jsx("br", {}),
                                        "All rights reserved."
                                    ]
                                }),
                                /*#__PURE__*/ _jsx(SocialLinks, {
                                    className: "nav social"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "col-md-4 col-lg-3",
                        children: /*#__PURE__*/ _jsxs("div", {
                            className: "widget",
                            children: [
                                /*#__PURE__*/ _jsx("h4", {
                                    className: "widget-title mb-3",
                                    children: "Get in Touch"
                                }),
                                /*#__PURE__*/ _jsxs("address", {
                                    className: "pe-xl-15 pe-xxl-17",
                                    children: [
                                        "Address ",
                                        /*#__PURE__*/ _jsx("br", {}),
                                        "London"
                                    ]
                                }),
                                /*#__PURE__*/ _jsx(NextLink, {
                                    title: "james@seoptimist.co.uk",
                                    href: "mailto:#",
                                    className: "link-body"
                                }),
                                /*#__PURE__*/ _jsx("br", {}),
                                " +44 (0) 7441 397 020"
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "col-md-4 col-lg-3",
                        children: /*#__PURE__*/ _jsxs("div", {
                            className: "widget",
                            children: [
                                /*#__PURE__*/ _jsx("h4", {
                                    className: "widget-title mb-3",
                                    children: "Learn More"
                                }),
                                /*#__PURE__*/ _jsx("ul", {
                                    className: "list-unstyled text-reset mb-0",
                                    children: footerNav.map(function(param) {
                                        var title = param.title, url = param.url;
                                        return /*#__PURE__*/ _jsx("li", {
                                            children: /*#__PURE__*/ _jsx(NextLink, {
                                                title: title,
                                                href: url
                                            })
                                        }, title);
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "col-md-12 col-lg-3",
                        children: /*#__PURE__*/ _jsxs("div", {
                            className: "widget",
                            children: [
                                /*#__PURE__*/ _jsx("h4", {
                                    className: "widget-title mb-3",
                                    children: "Our Newsletter"
                                }),
                                /*#__PURE__*/ _jsx("p", {
                                    className: "mb-5",
                                    children: "Subscribe to our newsletter to get our news & deals delivered to you."
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "newsletter-wrapper",
                                    children: /*#__PURE__*/ _jsx("div", {
                                        id: "mc_embed_signup2",
                                        children: /*#__PURE__*/ _jsx("form", {
                                            method: "post",
                                            target: "_blank",
                                            className: "validate dark-fields",
                                            id: "mc-embedded-subscribe-form2",
                                            name: "mc-embedded-subscribe-form",
                                            action: "https://elemisfreebies.us20.list-manage.com/subscribe/post?u=aa4947f70a475ce162057838d&id=b49ef47a9a",
                                            children: /*#__PURE__*/ _jsxs("div", {
                                                id: "mc_embed_signup_scroll2",
                                                children: [
                                                    /*#__PURE__*/ _jsxs("div", {
                                                        className: "mc-field-group input-group form-floating",
                                                        children: [
                                                            /*#__PURE__*/ _jsx("input", {
                                                                type: "email",
                                                                name: "EMAIL",
                                                                id: "mce-EMAIL2",
                                                                placeholder: "Email Address",
                                                                className: "required email form-control"
                                                            }),
                                                            /*#__PURE__*/ _jsx("label", {
                                                                htmlFor: "mce-EMAIL2",
                                                                children: "Email Address"
                                                            }),
                                                            /*#__PURE__*/ _jsx("input", {
                                                                value: "Join",
                                                                type: "submit",
                                                                name: "subscribe",
                                                                id: "mc-embedded-subscribe2",
                                                                className: "btn btn-primary btn-gradient gradient-1"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ _jsxs("div", {
                                                        id: "mce-responses2",
                                                        className: "clear",
                                                        children: [
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "response",
                                                                id: "mce-error-response2",
                                                                style: {
                                                                    display: "none"
                                                                }
                                                            }),
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "response",
                                                                id: "mce-success-response2",
                                                                style: {
                                                                    display: "none"
                                                                }
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ _jsx("div", {
                                                        style: {
                                                            position: "absolute",
                                                            left: "-5000px"
                                                        },
                                                        "aria-hidden": "true",
                                                        children: /*#__PURE__*/ _jsx("input", {
                                                            type: "text",
                                                            tabIndex: -1,
                                                            name: "b_ddc180777a163e0f9f66ee014_4b1bcfa0bc"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ _jsx("div", {
                                                        className: "clear"
                                                    })
                                                ]
                                            })
                                        })
                                    })
                                })
                            ]
                        })
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var footer_Footer11 = ((/* unused pure expression or super */ null && (Footer11)));

;// CONCATENATED MODULE: ./src/components/blocks/footer/Footer12.tsx



// -------- data -------- //

var Footer12 = function() {
    return /*#__PURE__*/ _jsx("footer", {
        className: "bg-dark text-inverse",
        children: /*#__PURE__*/ _jsx("div", {
            className: "container py-13 py-md-15",
            children: /*#__PURE__*/ _jsxs("div", {
                className: "row gy-6 gy-lg-0",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "col-md-4 col-lg-3",
                        children: /*#__PURE__*/ _jsxs("div", {
                            className: "widget",
                            children: [
                                /*#__PURE__*/ _jsx("img", {
                                    className: "mb-4",
                                    src: "/img/logo-light.png",
                                    srcSet: "/img/logo-light@2x.png 2x",
                                    alt: ""
                                }),
                                /*#__PURE__*/ _jsxs("p", {
                                    className: "mb-4",
                                    children: [
                                        "\xa9 2022 SEOptimist London. ",
                                        /*#__PURE__*/ _jsx("br", {}),
                                        "All rights reserved."
                                    ]
                                }),
                                /*#__PURE__*/ _jsx(SocialLinks, {
                                    className: "nav social social-white"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "col-md-4 col-lg-3",
                        children: /*#__PURE__*/ _jsxs("div", {
                            className: "widget",
                            children: [
                                /*#__PURE__*/ _jsx("h4", {
                                    className: "widget-title text-white mb-3",
                                    children: "Get in Touch"
                                }),
                                /*#__PURE__*/ _jsxs("address", {
                                    className: "pe-xl-15 pe-xxl-17",
                                    children: [
                                        "Address ",
                                        /*#__PURE__*/ _jsx("br", {}),
                                        "London"
                                    ]
                                }),
                                /*#__PURE__*/ _jsx("a", {
                                    href: "mailto:#",
                                    children: "james@seoptimist.co.uk"
                                }),
                                /*#__PURE__*/ _jsx("br", {}),
                                " +44 (0) 7441 397 020"
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "col-md-4 col-lg-3",
                        children: /*#__PURE__*/ _jsxs("div", {
                            className: "widget",
                            children: [
                                /*#__PURE__*/ _jsx("h4", {
                                    className: "widget-title text-white mb-3",
                                    children: "Learn More"
                                }),
                                /*#__PURE__*/ _jsx("ul", {
                                    className: "list-unstyled text-reset mb-0",
                                    children: footerNav.map(function(param) {
                                        var title = param.title, url = param.url;
                                        return /*#__PURE__*/ _jsx("li", {
                                            children: /*#__PURE__*/ _jsx(NextLink, {
                                                title: title,
                                                href: url
                                            })
                                        }, title);
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "col-md-12 col-lg-3",
                        children: /*#__PURE__*/ _jsxs("div", {
                            className: "widget",
                            children: [
                                /*#__PURE__*/ _jsx("h4", {
                                    className: "widget-title text-white mb-3",
                                    children: "Our Newsletter"
                                }),
                                /*#__PURE__*/ _jsx("p", {
                                    className: "mb-5",
                                    children: "Subscribe to our newsletter to get our news & deals delivered to you."
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "newsletter-wrapper",
                                    children: /*#__PURE__*/ _jsx("div", {
                                        id: "mc_embed_signup2",
                                        children: /*#__PURE__*/ _jsx("form", {
                                            method: "post",
                                            target: "_blank",
                                            className: "validate dark-fields",
                                            id: "mc-embedded-subscribe-form2",
                                            name: "mc-embedded-subscribe-form",
                                            action: "https://elemisfreebies.us20.list-manage.com/subscribe/post?u=aa4947f70a475ce162057838d&id=b49ef47a9a",
                                            children: /*#__PURE__*/ _jsxs("div", {
                                                id: "mc_embed_signup_scroll2",
                                                children: [
                                                    /*#__PURE__*/ _jsxs("div", {
                                                        className: "mc-field-group input-group form-floating",
                                                        children: [
                                                            /*#__PURE__*/ _jsx("input", {
                                                                type: "email",
                                                                name: "EMAIL",
                                                                id: "mce-EMAIL2",
                                                                placeholder: "Email Address",
                                                                className: "required email form-control"
                                                            }),
                                                            /*#__PURE__*/ _jsx("label", {
                                                                htmlFor: "mce-EMAIL2",
                                                                children: "Email Address"
                                                            }),
                                                            /*#__PURE__*/ _jsx("input", {
                                                                value: "Join",
                                                                type: "submit",
                                                                name: "subscribe",
                                                                id: "mc-embedded-subscribe2",
                                                                className: "btn btn-primary"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ _jsxs("div", {
                                                        id: "mce-responses2",
                                                        className: "clear",
                                                        children: [
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "response",
                                                                id: "mce-error-response2",
                                                                style: {
                                                                    display: "none"
                                                                }
                                                            }),
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "response",
                                                                id: "mce-success-response2",
                                                                style: {
                                                                    display: "none"
                                                                }
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ _jsx("div", {
                                                        style: {
                                                            position: "absolute",
                                                            left: "-5000px"
                                                        },
                                                        "aria-hidden": "true",
                                                        children: /*#__PURE__*/ _jsx("input", {
                                                            type: "text",
                                                            tabIndex: -1,
                                                            name: "b_ddc180777a163e0f9f66ee014_4b1bcfa0bc"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ _jsx("div", {
                                                        className: "clear"
                                                    })
                                                ]
                                            })
                                        })
                                    })
                                })
                            ]
                        })
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var footer_Footer12 = ((/* unused pure expression or super */ null && (Footer12)));

// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
;// CONCATENATED MODULE: ./src/components/blocks/footer/Footer13.tsx


// -------- custom component -------- //


// -------- data -------- //

var Footer13 = function() {
    return /*#__PURE__*/ _jsx("footer", {
        className: "bg-navy text-inverse",
        children: /*#__PURE__*/ _jsxs("div", {
            className: "container pt-12 pt-lg-6 pb-13 pb-md-15",
            children: [
                /*#__PURE__*/ _jsxs("div", {
                    className: "d-lg-flex flex-row align-items-lg-center",
                    children: [
                        /*#__PURE__*/ _jsx("h3", {
                            className: "display-3 mb-6 mb-lg-0 pe-lg-20 pe-xl-22 pe-xxl-25 text-white",
                            children: "Join Our Sucessful Clients By Using Our Services and grow your business."
                        }),
                        /*#__PURE__*/ _jsx(NextLink, {
                            href: "#",
                            title: "Try It For Free",
                            className: "btn btn-primary rounded-pill mb-0 text-nowrap"
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx("hr", {
                    className: "mt-11 mb-12"
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: "row gy-6 gy-lg-0",
                    children: [
                        /*#__PURE__*/ _jsx("div", {
                            className: "col-md-4 col-lg-3",
                            children: /*#__PURE__*/ _jsxs("div", {
                                className: "widget",
                                children: [
                                    /*#__PURE__*/ _jsx("figure", {
                                        className: "mb-4",
                                        children: /*#__PURE__*/ _jsx(Image, {
                                            layout: "responsive",
                                            alt: "logo",
                                            width: 134,
                                            height: 26,
                                            src: "/img/logo-light.png"
                                        })
                                    }),
                                    /*#__PURE__*/ _jsxs("p", {
                                        className: "mb-4",
                                        children: [
                                            "\xa9 2022 SEOptimist London. ",
                                            /*#__PURE__*/ _jsx("br", {}),
                                            "All rights reserved."
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsx(SocialLinks, {
                                        className: "nav social social-white"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "col-md-4 col-lg-3",
                            children: /*#__PURE__*/ _jsxs("div", {
                                className: "widget",
                                children: [
                                    /*#__PURE__*/ _jsx("h4", {
                                        className: "widget-title text-white mb-3",
                                        children: "Get in Touch"
                                    }),
                                    /*#__PURE__*/ _jsxs("address", {
                                        className: "pe-xl-15 pe-xxl-17",
                                        children: [
                                            "Address ",
                                            /*#__PURE__*/ _jsx("br", {}),
                                            "London"
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsx(NextLink, {
                                        title: "james@seoptimist.co.uk",
                                        href: "mailto:#"
                                    }),
                                    /*#__PURE__*/ _jsx("br", {}),
                                    " +44 (0) 7441 397 020"
                                ]
                            })
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "col-md-4 col-lg-3",
                            children: /*#__PURE__*/ _jsxs("div", {
                                className: "widget",
                                children: [
                                    /*#__PURE__*/ _jsx("h4", {
                                        className: "widget-title text-white mb-3",
                                        children: "Learn More"
                                    }),
                                    /*#__PURE__*/ _jsx("ul", {
                                        className: "list-unstyled mb-0",
                                        children: footerNav.map(function(param) {
                                            var title = param.title, url = param.url;
                                            return /*#__PURE__*/ _jsx("li", {
                                                children: /*#__PURE__*/ _jsx(NextLink, {
                                                    title: title,
                                                    href: url
                                                })
                                            }, title);
                                        })
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "col-md-12 col-lg-3",
                            children: /*#__PURE__*/ _jsxs("div", {
                                className: "widget",
                                children: [
                                    /*#__PURE__*/ _jsx("h4", {
                                        className: "widget-title text-white mb-3",
                                        children: "Our Newsletter"
                                    }),
                                    /*#__PURE__*/ _jsx("p", {
                                        className: "mb-5",
                                        children: "Subscribe to our newsletter to get our news & deals delivered to you."
                                    }),
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "newsletter-wrapper",
                                        children: /*#__PURE__*/ _jsx("div", {
                                            id: "mc_embed_signup2",
                                            children: /*#__PURE__*/ _jsx("form", {
                                                method: "post",
                                                target: "_blank",
                                                className: "validate dark-fields",
                                                id: "mc-embedded-subscribe-form2",
                                                name: "mc-embedded-subscribe-form",
                                                action: "https://elemisfreebies.us20.list-manage.com/subscribe/post?u=aa4947f70a475ce162057838d&id=b49ef47a9a",
                                                children: /*#__PURE__*/ _jsxs("div", {
                                                    id: "mc_embed_signup_scroll2",
                                                    children: [
                                                        /*#__PURE__*/ _jsxs("div", {
                                                            className: "mc-field-group input-group form-floating",
                                                            children: [
                                                                /*#__PURE__*/ _jsx("input", {
                                                                    type: "email",
                                                                    name: "EMAIL",
                                                                    id: "mce-EMAIL2",
                                                                    placeholder: "Email Address",
                                                                    className: "required email form-control"
                                                                }),
                                                                /*#__PURE__*/ _jsx("label", {
                                                                    htmlFor: "mce-EMAIL2",
                                                                    children: "Email Address"
                                                                }),
                                                                /*#__PURE__*/ _jsx("input", {
                                                                    value: "Join",
                                                                    type: "submit",
                                                                    name: "subscribe",
                                                                    id: "mc-embedded-subscribe2",
                                                                    className: "btn btn-primary"
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ _jsxs("div", {
                                                            id: "mce-responses2",
                                                            className: "clear",
                                                            children: [
                                                                /*#__PURE__*/ _jsx("div", {
                                                                    className: "response",
                                                                    id: "mce-error-response2",
                                                                    style: {
                                                                        display: "none"
                                                                    }
                                                                }),
                                                                /*#__PURE__*/ _jsx("div", {
                                                                    className: "response",
                                                                    id: "mce-success-response2",
                                                                    style: {
                                                                        display: "none"
                                                                    }
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ _jsx("div", {
                                                            style: {
                                                                position: "absolute",
                                                                left: "-5000px"
                                                            },
                                                            "aria-hidden": "true",
                                                            children: /*#__PURE__*/ _jsx("input", {
                                                                type: "text",
                                                                tabIndex: -1,
                                                                name: "b_ddc180777a163e0f9f66ee014_4b1bcfa0bc"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ _jsx("div", {
                                                            className: "clear"
                                                        })
                                                    ]
                                                })
                                            })
                                        })
                                    })
                                ]
                            })
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var footer_Footer13 = ((/* unused pure expression or super */ null && (Footer13)));

;// CONCATENATED MODULE: ./src/components/blocks/footer/Footer14.tsx


// -------- custom component -------- //


// -------- data -------- //

var Footer14 = function() {
    return /*#__PURE__*/ _jsx("footer", {
        className: "bg-dark section-frame mt-15",
        children: /*#__PURE__*/ _jsxs("div", {
            className: "container pb-13 pb-md-15",
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "card image-wrapper bg-full bg-image bg-overlay mt-n50p mx-md-5",
                    style: {
                        backgroundImage: "url(/img/photos/bg27.jpg)"
                    },
                    children: /*#__PURE__*/ _jsxs("div", {
                        className: "card-body p-6 p-md-11 d-lg-flex flex-row align-items-lg-center justify-content-md-between text-center text-lg-start",
                        children: [
                            /*#__PURE__*/ _jsx("h3", {
                                className: "display-4 mb-6 mb-lg-0 pe-lg-10 pe-xl-5 pe-xxl-18 text-white",
                                children: "We are trusted by over 5000+ clients. Join them by using our services and grow your business."
                            }),
                            /*#__PURE__*/ _jsx(NextLink, {
                                title: "Join Us",
                                href: "#",
                                className: "btn btn-lg btn-white rounded mb-0 text-nowrap"
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "text-inverse mx-md-5 mt-n15 mt-lg-0",
                    children: /*#__PURE__*/ _jsxs("div", {
                        className: "row gy-6 gy-lg-0",
                        children: [
                            /*#__PURE__*/ _jsx("div", {
                                className: "col-md-4 col-lg-3",
                                children: /*#__PURE__*/ _jsxs("div", {
                                    className: "widget",
                                    children: [
                                        /*#__PURE__*/ _jsx("figure", {
                                            className: "mb-4",
                                            children: /*#__PURE__*/ _jsx(Image, {
                                                layout: "responsive",
                                                alt: "logo",
                                                width: 134,
                                                height: 26,
                                                src: "/img/logo-light.png"
                                            })
                                        }),
                                        /*#__PURE__*/ _jsxs("p", {
                                            className: "mb-4",
                                            children: [
                                                "\xa9 2022 SEOptimist London. ",
                                                /*#__PURE__*/ _jsx("br", {}),
                                                "All rights reserved."
                                            ]
                                        }),
                                        /*#__PURE__*/ _jsx(SocialLinks, {
                                            className: "nav social social-white"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: "col-md-4 col-lg-3",
                                children: /*#__PURE__*/ _jsxs("div", {
                                    className: "widget",
                                    children: [
                                        /*#__PURE__*/ _jsx("h4", {
                                            className: "widget-title text-white mb-3",
                                            children: "Get in Touch"
                                        }),
                                        /*#__PURE__*/ _jsxs("address", {
                                            className: "pe-xl-15 pe-xxl-17",
                                            children: [
                                                "Address ",
                                                /*#__PURE__*/ _jsx("br", {}),
                                                "London"
                                            ]
                                        }),
                                        /*#__PURE__*/ _jsx(NextLink, {
                                            title: "james@seoptimist.co.uk",
                                            href: "mailto:#"
                                        }),
                                        /*#__PURE__*/ _jsx("br", {}),
                                        " +44 (0) 7441 397 020"
                                    ]
                                })
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: "col-md-4 col-lg-3",
                                children: /*#__PURE__*/ _jsxs("div", {
                                    className: "widget",
                                    children: [
                                        /*#__PURE__*/ _jsx("h4", {
                                            className: "widget-title text-white mb-3",
                                            children: "Learn More"
                                        }),
                                        /*#__PURE__*/ _jsx("ul", {
                                            className: "list-unstyled mb-0",
                                            children: footerNav.map(function(param) {
                                                var title = param.title, url = param.url;
                                                return /*#__PURE__*/ _jsx("li", {
                                                    children: /*#__PURE__*/ _jsx(NextLink, {
                                                        title: title,
                                                        href: url
                                                    })
                                                }, title);
                                            })
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: "col-md-12 col-lg-3",
                                children: /*#__PURE__*/ _jsxs("div", {
                                    className: "widget",
                                    children: [
                                        /*#__PURE__*/ _jsx("h4", {
                                            className: "widget-title text-white mb-3",
                                            children: "Our Newsletter"
                                        }),
                                        /*#__PURE__*/ _jsx("p", {
                                            className: "mb-5",
                                            children: "Subscribe to our newsletter to get our news & deals delivered to you."
                                        }),
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "newsletter-wrapper",
                                            children: /*#__PURE__*/ _jsx("div", {
                                                id: "mc_embed_signup2",
                                                children: /*#__PURE__*/ _jsx("form", {
                                                    method: "post",
                                                    target: "_blank",
                                                    className: "validate dark-fields",
                                                    id: "mc-embedded-subscribe-form2",
                                                    name: "mc-embedded-subscribe-form",
                                                    action: "https://elemisfreebies.us20.list-manage.com/subscribe/post?u=aa4947f70a475ce162057838d&id=b49ef47a9a",
                                                    children: /*#__PURE__*/ _jsxs("div", {
                                                        id: "mc_embed_signup_scroll2",
                                                        children: [
                                                            /*#__PURE__*/ _jsxs("div", {
                                                                className: "mc-field-group input-group form-floating",
                                                                children: [
                                                                    /*#__PURE__*/ _jsx("input", {
                                                                        type: "email",
                                                                        name: "EMAIL",
                                                                        id: "mce-EMAIL2",
                                                                        placeholder: "Email Address",
                                                                        className: "required email form-control"
                                                                    }),
                                                                    /*#__PURE__*/ _jsx("label", {
                                                                        htmlFor: "mce-EMAIL2",
                                                                        children: "Email Address"
                                                                    }),
                                                                    /*#__PURE__*/ _jsx("input", {
                                                                        value: "Join",
                                                                        type: "submit",
                                                                        name: "subscribe",
                                                                        id: "mc-embedded-subscribe2",
                                                                        className: "btn btn-primary"
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ _jsxs("div", {
                                                                id: "mce-responses2",
                                                                className: "clear",
                                                                children: [
                                                                    /*#__PURE__*/ _jsx("div", {
                                                                        className: "response",
                                                                        id: "mce-error-response2",
                                                                        style: {
                                                                            display: "none"
                                                                        }
                                                                    }),
                                                                    /*#__PURE__*/ _jsx("div", {
                                                                        className: "response",
                                                                        id: "mce-success-response2",
                                                                        style: {
                                                                            display: "none"
                                                                        }
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ _jsx("div", {
                                                                style: {
                                                                    position: "absolute",
                                                                    left: "-5000px"
                                                                },
                                                                "aria-hidden": "true",
                                                                children: /*#__PURE__*/ _jsx("input", {
                                                                    type: "text",
                                                                    tabIndex: -1,
                                                                    name: "b_ddc180777a163e0f9f66ee014_4b1bcfa0bc"
                                                                })
                                                            }),
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "clear"
                                                            })
                                                        ]
                                                    })
                                                })
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var footer_Footer14 = ((/* unused pure expression or super */ null && (Footer14)));

;// CONCATENATED MODULE: ./src/components/blocks/footer/Footer15.tsx


var Footer15 = function() {
    return /*#__PURE__*/ _jsx("footer", {
        className: "bg-gray",
        children: /*#__PURE__*/ _jsxs("div", {
            className: "container pt-13 pb-7",
            children: [
                /*#__PURE__*/ _jsxs("div", {
                    className: "row gx-lg-0 gy-6",
                    children: [
                        /*#__PURE__*/ _jsx("div", {
                            className: "col-lg-4",
                            children: /*#__PURE__*/ _jsxs("div", {
                                className: "widget",
                                children: [
                                    /*#__PURE__*/ _jsx("img", {
                                        className: "mb-4",
                                        src: "/img/logo-dark.png",
                                        srcSet: "/img/logo-dark@2x.png 2x",
                                        alt: ""
                                    }),
                                    /*#__PURE__*/ _jsx("p", {
                                        className: "lead mb-0",
                                        children: "I'm SEOptimist , a photographer specializing in food, drink and product photography."
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "col-lg-3 offset-lg-2",
                            children: /*#__PURE__*/ _jsx("div", {
                                className: "widget",
                                children: /*#__PURE__*/ _jsxs("div", {
                                    className: "d-flex flex-row",
                                    children: [
                                        /*#__PURE__*/ _jsx("div", {
                                            children: /*#__PURE__*/ _jsx("div", {
                                                className: "icon text-primary fs-28 me-4 mt-n1",
                                                children: /*#__PURE__*/ _jsx("i", {
                                                    className: "uil uil-phone-volume"
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ _jsxs("div", {
                                            children: [
                                                /*#__PURE__*/ _jsx("h5", {
                                                    className: "mb-1",
                                                    children: "Phone"
                                                }),
                                                /*#__PURE__*/ _jsxs("p", {
                                                    className: "mb-0",
                                                    children: [
                                                        "+44 (0) 7441 397 020 ",
                                                        /*#__PURE__*/ _jsx("br", {}),
                                                        "00 (987) 654 32 10"
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "col-lg-3",
                            children: /*#__PURE__*/ _jsx("div", {
                                className: "widget",
                                children: /*#__PURE__*/ _jsxs("div", {
                                    className: "d-flex flex-row",
                                    children: [
                                        /*#__PURE__*/ _jsx("div", {
                                            children: /*#__PURE__*/ _jsx("div", {
                                                className: "icon text-primary fs-28 me-4 mt-n1",
                                                children: /*#__PURE__*/ _jsx("i", {
                                                    className: "uil uil-location-pin-alt"
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ _jsxs("div", {
                                            className: "align-self-start justify-content-start",
                                            children: [
                                                /*#__PURE__*/ _jsx("h5", {
                                                    className: "mb-1",
                                                    children: "Address"
                                                }),
                                                /*#__PURE__*/ _jsxs("address", {
                                                    children: [
                                                        "Address ",
                                                        /*#__PURE__*/ _jsx("br", {}),
                                                        "London"
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx("hr", {
                    className: "mt-11 mt-md-12 mb-7"
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: "d-md-flex align-items-center justify-content-between",
                    children: [
                        /*#__PURE__*/ _jsxs("p", {
                            className: "mb-2 mb-lg-0",
                            children: [
                                "\xa9 2022 SEOptimist London. ",
                                /*#__PURE__*/ _jsx("br", {}),
                                "All rights reserved."
                            ]
                        }),
                        /*#__PURE__*/ _jsx(SocialLinks, {
                            className: "nav social social-muted mb-0 text-md-end"
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var footer_Footer15 = ((/* unused pure expression or super */ null && (Footer15)));

;// CONCATENATED MODULE: ./src/components/blocks/footer/Footer16.tsx


// -------- custom component -------- //


// -------- data -------- //

var Footer16 = function() {
    return /*#__PURE__*/ _jsx("footer", {
        className: "bg-dark text-inverse",
        children: /*#__PURE__*/ _jsxs("div", {
            className: "container py-13 py-md-15",
            children: [
                /*#__PURE__*/ _jsxs("div", {
                    className: "row gy-6 gy-lg-0",
                    children: [
                        /*#__PURE__*/ _jsxs("div", {
                            className: "col-md-4 col-lg-3",
                            children: [
                                /*#__PURE__*/ _jsx("h4", {
                                    className: "widget-title text-white mb-3",
                                    children: "Popular Posts"
                                }),
                                /*#__PURE__*/ _jsxs("ul", {
                                    className: "image-list",
                                    children: [
                                        /*#__PURE__*/ _jsxs("li", {
                                            children: [
                                                /*#__PURE__*/ _jsx(Link, {
                                                    // legacyBehavior2 passHref2 
                                                    href: "#",
                                                    children: /*#__PURE__*/ _jsx("a", {
                                                        children: /*#__PURE__*/ _jsx("figure", {
                                                            className: "rounded",
                                                            children: /*#__PURE__*/ _jsx("img", {
                                                                src: "/img/photos/a4.jpg",
                                                                alt: ""
                                                            })
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ _jsxs("div", {
                                                    className: "post-content",
                                                    children: [
                                                        /*#__PURE__*/ _jsx("h6", {
                                                            className: "mb-2",
                                                            children: /*#__PURE__*/ _jsx(NextLink, {
                                                                title: "Magna Mollis Ultricies",
                                                                className: "link-dark",
                                                                href: "#"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ _jsx("ul", {
                                                            className: "post-meta",
                                                            children: /*#__PURE__*/ _jsxs("li", {
                                                                className: "post-date",
                                                                children: [
                                                                    /*#__PURE__*/ _jsx("i", {
                                                                        className: "uil uil-calendar-alt"
                                                                    }),
                                                                    /*#__PURE__*/ _jsx("span", {
                                                                        children: "26 Mar 2022"
                                                                    })
                                                                ]
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ _jsxs("li", {
                                            className: "mt-5",
                                            children: [
                                                /*#__PURE__*/ _jsx(Link, {
                                                    // legacyBehavior2 passHref2 
                                                    href: "#",
                                                    children: /*#__PURE__*/ _jsx("a", {
                                                        children: /*#__PURE__*/ _jsx("figure", {
                                                            className: "rounded",
                                                            children: /*#__PURE__*/ _jsx("img", {
                                                                src: "/img/photos/a5.jpg",
                                                                alt: ""
                                                            })
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ _jsxs("div", {
                                                    className: "post-content",
                                                    children: [
                                                        /*#__PURE__*/ _jsx("h6", {
                                                            className: "mb-2",
                                                            children: /*#__PURE__*/ _jsx(NextLink, {
                                                                title: "Ornare Nullam Risus",
                                                                className: "link-dark",
                                                                href: "#"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ _jsx("ul", {
                                                            className: "post-meta",
                                                            children: /*#__PURE__*/ _jsxs("li", {
                                                                className: "post-date",
                                                                children: [
                                                                    /*#__PURE__*/ _jsx("i", {
                                                                        className: "uil uil-calendar-alt"
                                                                    }),
                                                                    /*#__PURE__*/ _jsx("span", {
                                                                        children: "16 Feb 2022"
                                                                    })
                                                                ]
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ _jsxs("li", {
                                            className: "mt-5",
                                            children: [
                                                /*#__PURE__*/ _jsx(Link, {
                                                    // legacyBehavior2 passHref2 
                                                    href: "#",
                                                    children: /*#__PURE__*/ _jsx("a", {
                                                        children: /*#__PURE__*/ _jsx("figure", {
                                                            className: "rounded",
                                                            children: /*#__PURE__*/ _jsx("img", {
                                                                src: "/img/photos/a6.jpg",
                                                                alt: ""
                                                            })
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ _jsxs("div", {
                                                    className: "post-content",
                                                    children: [
                                                        /*#__PURE__*/ _jsx("h6", {
                                                            className: "mb-2",
                                                            children: /*#__PURE__*/ _jsx(NextLink, {
                                                                title: "Euismod Nullam Fusce",
                                                                className: "link-dark",
                                                                href: "#"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ _jsx("ul", {
                                                            className: "post-meta",
                                                            children: /*#__PURE__*/ _jsxs("li", {
                                                                className: "post-date",
                                                                children: [
                                                                    /*#__PURE__*/ _jsx("i", {
                                                                        className: "uil uil-calendar-alt"
                                                                    }),
                                                                    /*#__PURE__*/ _jsx("span", {
                                                                        children: "8 Jan 2022"
                                                                    })
                                                                ]
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            className: "col-md-4 col-lg-3",
                            children: [
                                /*#__PURE__*/ _jsxs("div", {
                                    className: "widget",
                                    children: [
                                        /*#__PURE__*/ _jsx("h4", {
                                            className: "widget-title text-white mb-3",
                                            children: "Tags"
                                        }),
                                        /*#__PURE__*/ _jsx("ul", {
                                            className: "list-unstyled tag-list",
                                            children: tags.map(function(param) {
                                                var id = param.id, title = param.title, url = param.url;
                                                return /*#__PURE__*/ _jsx("li", {
                                                    children: /*#__PURE__*/ _jsx(NextLink, {
                                                        title: title,
                                                        href: url,
                                                        className: "btn btn-soft-ash text-white btn-sm rounded-pill"
                                                    })
                                                }, id);
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs("div", {
                                    className: "widget",
                                    children: [
                                        /*#__PURE__*/ _jsx("h4", {
                                            className: "widget-title text-white mb-3",
                                            children: "Categories"
                                        }),
                                        /*#__PURE__*/ _jsx("ul", {
                                            className: "unordered-list text-reset bullet-white ",
                                            children: categories.map(function(param) {
                                                var id = param.id, post = param.post, title = param.title, url = param.url;
                                                return /*#__PURE__*/ _jsx("li", {
                                                    children: /*#__PURE__*/ _jsx(NextLink, {
                                                        title: "".concat(title, " (").concat(post, ")"),
                                                        href: url
                                                    })
                                                }, id);
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            className: "col-md-4 col-lg-3",
                            children: [
                                /*#__PURE__*/ _jsxs("div", {
                                    className: "widget",
                                    children: [
                                        /*#__PURE__*/ _jsx("h4", {
                                            className: "widget-title text-white mb-3",
                                            children: "Get in Touch"
                                        }),
                                        /*#__PURE__*/ _jsxs("address", {
                                            className: "pe-xl-15 pe-xxl-17",
                                            children: [
                                                "Address ",
                                                /*#__PURE__*/ _jsx("br", {}),
                                                "London"
                                            ]
                                        }),
                                        /*#__PURE__*/ _jsx("a", {
                                            href: "mailto:#",
                                            children: "james@seoptimist.co.uk"
                                        }),
                                        /*#__PURE__*/ _jsx("br", {}),
                                        " +44 (0) 7441 397 020"
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs("div", {
                                    className: "widget",
                                    children: [
                                        /*#__PURE__*/ _jsx("h4", {
                                            className: "widget-title text-white mb-3",
                                            children: "Elsewhere"
                                        }),
                                        /*#__PURE__*/ _jsx(SocialLinks, {
                                            className: "nav social social-white"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            className: "col-md-4 col-lg-3",
                            children: [
                                /*#__PURE__*/ _jsxs("div", {
                                    className: "widget",
                                    children: [
                                        /*#__PURE__*/ _jsx("h4", {
                                            className: "widget-title text-white mb-3",
                                            children: "Learn More"
                                        }),
                                        /*#__PURE__*/ _jsxs("ul", {
                                            className: "list-unstyled text-reset mb-0",
                                            children: [
                                                /*#__PURE__*/ _jsx("li", {
                                                    children: /*#__PURE__*/ _jsx(Link, {
                                                        // legacyBehavior2 passHref2 
                                                        href: "#",
                                                        children: "About Us"
                                                    })
                                                }),
                                                /*#__PURE__*/ _jsx("li", {
                                                    children: /*#__PURE__*/ _jsx(Link, {
                                                        // legacyBehavior2 passHref2 
                                                        href: "#",
                                                        children: "Our Story"
                                                    })
                                                }),
                                                /*#__PURE__*/ _jsx("li", {
                                                    children: /*#__PURE__*/ _jsx(Link, {
                                                        // legacyBehavior2 passHref2 
                                                        href: "#",
                                                        children: "Projects"
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs("div", {
                                    className: "widget",
                                    children: [
                                        /*#__PURE__*/ _jsx("h4", {
                                            className: "widget-title text-white mb-3",
                                            children: "Need Help?"
                                        }),
                                        /*#__PURE__*/ _jsxs("ul", {
                                            className: "list-unstyled text-reset mb-0",
                                            children: [
                                                /*#__PURE__*/ _jsx("li", {
                                                    children: /*#__PURE__*/ _jsx(Link, {
                                                        // legacyBehavior2 passHref2 
                                                        href: "#",
                                                        children: "Support"
                                                    })
                                                }),
                                                /*#__PURE__*/ _jsx("li", {
                                                    children: /*#__PURE__*/ _jsx(Link, {
                                                        // legacyBehavior2 passHref2 
                                                        href: "#",
                                                        children: "Get Started"
                                                    })
                                                }),
                                                /*#__PURE__*/ _jsx("li", {
                                                    children: /*#__PURE__*/ _jsx(Link, {
                                                        // legacyBehavior2 passHref2 
                                                        href: "#",
                                                        children: "Contact Us"
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ _jsxs("p", {
                    className: "mt-6 mb-0 text-center",
                    children: [
                        "\xa9 2022 SEOptimist London. ",
                        /*#__PURE__*/ _jsx("br", {}),
                        "All rights reserved."
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var footer_Footer16 = ((/* unused pure expression or super */ null && (Footer16)));

// EXTERNAL MODULE: ./src/components/reuseable/IconBox.tsx
var reuseable_IconBox = __webpack_require__(50220);
;// CONCATENATED MODULE: ./src/components/blocks/footer/Footer17.tsx

// -------- custom component -------- //


var Footer17 = function() {
    return /*#__PURE__*/ _jsx("footer", {
        className: "bg-white",
        children: /*#__PURE__*/ _jsxs("div", {
            className: "container pt-8 pt-md-10 pb-7",
            children: [
                /*#__PURE__*/ _jsxs("div", {
                    className: "row gx-lg-0 gy-6",
                    children: [
                        /*#__PURE__*/ _jsx("div", {
                            className: "col-lg-4",
                            children: /*#__PURE__*/ _jsxs("div", {
                                className: "widget",
                                children: [
                                    /*#__PURE__*/ _jsx("img", {
                                        className: "mb-4",
                                        src: "/img/logo-dark.png",
                                        srcSet: "/img/logo-dark@2x.png 2x",
                                        alt: ""
                                    }),
                                    /*#__PURE__*/ _jsx("p", {
                                        className: "lead mb-0",
                                        children: "We are trusted by over 5000+ clients. Join them by using our services and grow your business."
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "col-lg-3 offset-lg-2",
                            children: /*#__PURE__*/ _jsx("div", {
                                className: "widget",
                                children: /*#__PURE__*/ _jsxs("div", {
                                    className: "d-flex flex-row",
                                    children: [
                                        /*#__PURE__*/ _jsx(IconBox, {
                                            icon: "uil-phone-volume",
                                            className: "icon text-primary fs-28 me-4 mt-n1"
                                        }),
                                        /*#__PURE__*/ _jsxs("div", {
                                            children: [
                                                /*#__PURE__*/ _jsx("h5", {
                                                    className: "mb-1",
                                                    children: "Phone"
                                                }),
                                                /*#__PURE__*/ _jsxs("p", {
                                                    className: "mb-0",
                                                    children: [
                                                        "+44 (0) 7441 397 020 ",
                                                        /*#__PURE__*/ _jsx("br", {}),
                                                        "00 (987) 654 32 10"
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "col-lg-3",
                            children: /*#__PURE__*/ _jsx("div", {
                                className: "widget",
                                children: /*#__PURE__*/ _jsxs("div", {
                                    className: "d-flex flex-row",
                                    children: [
                                        /*#__PURE__*/ _jsx(IconBox, {
                                            icon: "uil-location-pin-alt",
                                            className: "icon text-primary fs-28 me-4 mt-n1"
                                        }),
                                        /*#__PURE__*/ _jsxs("div", {
                                            className: "align-self-start justify-content-start",
                                            children: [
                                                /*#__PURE__*/ _jsx("h5", {
                                                    className: "mb-1",
                                                    children: "Address"
                                                }),
                                                /*#__PURE__*/ _jsxs("address", {
                                                    children: [
                                                        "Address ",
                                                        /*#__PURE__*/ _jsx("br", {}),
                                                        "London"
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx("hr", {
                    className: "mt-13 mt-md-14 mb-7"
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: "d-md-flex align-items-center justify-content-between",
                    children: [
                        /*#__PURE__*/ _jsxs("p", {
                            className: "mb-2 mb-lg-0",
                            children: [
                                "\xa9 2022 SEOptimist London. ",
                                /*#__PURE__*/ _jsx("br", {}),
                                "All rights reserved."
                            ]
                        }),
                        /*#__PURE__*/ _jsx(SocialLinks, {
                            className: "nav social social-muted mb-0 text-md-end"
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var footer_Footer17 = ((/* unused pure expression or super */ null && (Footer17)));

;// CONCATENATED MODULE: ./src/components/blocks/footer/Footer18.tsx

// -------- custom component -------- //


// -------- data -------- //

var Footer18 = function() {
    return /*#__PURE__*/ _jsx("footer", {
        className: "bg-gray",
        children: /*#__PURE__*/ _jsxs("div", {
            className: "container py-13 py-md-15",
            children: [
                /*#__PURE__*/ _jsxs("div", {
                    className: "d-lg-flex flex-row align-items-lg-center",
                    children: [
                        /*#__PURE__*/ _jsx("h3", {
                            className: "display-3 ls-sm mb-6 mb-lg-0 pe-lg-20 pe-xl-22 pe-xxl-25",
                            children: "Join Our Sucessful Clients By Using Our Services and grow your business."
                        }),
                        /*#__PURE__*/ _jsx(NextLink, {
                            title: "Try It For Free",
                            href: "#",
                            className: "btn btn-lg btn-primary rounded mb-0 text-nowrap"
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx("hr", {
                    className: "mt-11 mb-12"
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: "row gy-6 gy-lg-0",
                    children: [
                        /*#__PURE__*/ _jsx("div", {
                            className: "col-md-4 col-lg-3",
                            children: /*#__PURE__*/ _jsxs("div", {
                                className: "widget",
                                children: [
                                    /*#__PURE__*/ _jsx("img", {
                                        className: "mb-4",
                                        src: "/img/logo-dark.png",
                                        srcSet: "/img/logo-dark@2x.png 2x",
                                        alt: ""
                                    }),
                                    /*#__PURE__*/ _jsxs("p", {
                                        className: "mb-4",
                                        children: [
                                            "\xa9 2022 SEOptimist London. ",
                                            /*#__PURE__*/ _jsx("br", {}),
                                            "All rights reserved."
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsx(SocialLinks, {
                                        className: "nav social social-muted"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "col-md-4 col-lg-3",
                            children: /*#__PURE__*/ _jsxs("div", {
                                className: "widget",
                                children: [
                                    /*#__PURE__*/ _jsx("h4", {
                                        className: "widget-title ls-sm mb-3",
                                        children: "Get in Touch"
                                    }),
                                    /*#__PURE__*/ _jsxs("address", {
                                        className: "pe-xl-15 pe-xxl-17",
                                        children: [
                                            "Address ",
                                            /*#__PURE__*/ _jsx("br", {}),
                                            "London"
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsx("a", {
                                        href: "mailto:#",
                                        className: "link-body",
                                        children: "james@seoptimist.co.uk"
                                    }),
                                    /*#__PURE__*/ _jsx("br", {}),
                                    " +44 (0) 7441 397 020"
                                ]
                            })
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "col-md-4 col-lg-3",
                            children: /*#__PURE__*/ _jsxs("div", {
                                className: "widget",
                                children: [
                                    /*#__PURE__*/ _jsx("h4", {
                                        className: "widget-title ls-sm mb-3",
                                        children: "Learn More"
                                    }),
                                    /*#__PURE__*/ _jsx("ul", {
                                        className: "list-unstyled text-reset mb-0",
                                        children: footerNav.map(function(param) {
                                            var title = param.title, url = param.url;
                                            return /*#__PURE__*/ _jsx("li", {
                                                children: /*#__PURE__*/ _jsx(NextLink, {
                                                    title: title,
                                                    href: url
                                                })
                                            }, title);
                                        })
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "col-md-12 col-lg-3",
                            children: /*#__PURE__*/ _jsxs("div", {
                                className: "widget",
                                children: [
                                    /*#__PURE__*/ _jsx("h4", {
                                        className: "widget-title ls-sm mb-3",
                                        children: "Our Newsletter"
                                    }),
                                    /*#__PURE__*/ _jsx("p", {
                                        className: "mb-5",
                                        children: "Subscribe to our newsletter to get our news & deals delivered to you."
                                    }),
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "newsletter-wrapper",
                                        children: /*#__PURE__*/ _jsx("div", {
                                            id: "mc_embed_signup2",
                                            children: /*#__PURE__*/ _jsxs("form", {
                                                method: "post",
                                                "data-netlify": "true",
                                                action: "https://seoptimist.co.uk/",
                                                // data-netlify-honeypot="bot-field"
                                                id: "mc-embedded-subscribe-form2",
                                                name: "mc-embedded-subscribe-form",
                                                className: "validate",
                                                target: "_blank",
                                                noValidate: true,
                                                children: [
                                                    /*#__PURE__*/ _jsx("input", {
                                                        type: "hidden",
                                                        name: "form-name",
                                                        value: "mc-embedded-subscribe-form"
                                                    }),
                                                    /*#__PURE__*/ _jsx("p", {
                                                        className: "d-none",
                                                        children: /*#__PURE__*/ _jsx("label", {
                                                            children: /*#__PURE__*/ _jsx("input", {
                                                                name: "bot-field"
                                                            })
                                                        })
                                                    }),
                                                    /*#__PURE__*/ _jsx("div", {
                                                        id: "mc_embed_signup_scroll2",
                                                        children: /*#__PURE__*/ _jsxs("div", {
                                                            className: "mc-field-group input-group form-floating",
                                                            children: [
                                                                /*#__PURE__*/ _jsx("input", {
                                                                    type: "email",
                                                                    name: "EMAIL",
                                                                    id: "mce-EMAIL2",
                                                                    placeholder: "Email Address",
                                                                    className: "required email form-control"
                                                                }),
                                                                /*#__PURE__*/ _jsx("label", {
                                                                    htmlFor: "mce-EMAIL2",
                                                                    children: "Email Address"
                                                                }),
                                                                /*#__PURE__*/ _jsx("input", {
                                                                    type: "submit",
                                                                    value: "Join",
                                                                    name: "subscribe",
                                                                    id: "mc-embedded-subscribe2",
                                                                    className: "btn btn-primary"
                                                                })
                                                            ]
                                                        })
                                                    })
                                                ]
                                            })
                                        })
                                    })
                                ]
                            })
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var footer_Footer18 = ((/* unused pure expression or super */ null && (Footer18)));

;// CONCATENATED MODULE: ./src/components/blocks/footer/index.ts





















/***/ }),

/***/ 2034:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_script__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4298);
/* harmony import */ var next_script__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_script__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_3__);




var SEO = function(param) {
    var _sitename = param.sitename, sitename = _sitename === void 0 ? "SEOptimist" : _sitename, _siteUrl = param.siteUrl, siteUrl = _siteUrl === void 0 ? "https://seoptimist.co.uk" : _siteUrl, _siteUrlPT = param.siteUrlPT, siteUrlPT = _siteUrlPT === void 0 ? "https://seoptimist.pt" : _siteUrlPT, _logopath = param.logopath, logopath = _logopath === void 0 ? "https://seoptimist.co.uk/email-img/seoptimist-logo-black.png" : _logopath, _author = param.author, author = _author === void 0 ? "SEOptimist" : _author, _linkedIn = param.linkedIn, linkedIn = _linkedIn === void 0 ? "https://www.linkedin.com/in/finlaysonj/" : _linkedIn, _telephone = param.telephone, telephone = _telephone === void 0 ? "+44 07480 603 345" : _telephone, _address = param.address, address = _address === void 0 ? "9 Moreland St" : _address, _local = param.local, local = _local === void 0 ? "London, United Kingdom" : _local, _postcode = param.postcode, postcode = _postcode === void 0 ? "EC1V 8BE" : _postcode, _country = param.country, country = _country === void 0 ? "UK" : _country, _latitude = param.latitude, latitude = _latitude === void 0 ? "51.529206652814715" : _latitude, _longitude = param.longitude, longitude = _longitude === void 0 ? "-0.09873897116400623" : _longitude, tag = param.tag, image = param.image, _title = param.title, title = _title === void 0 ? "" : _title, description = param.description, url = param.url, urlPT = param.urlPT, urlENPT = param.urlENPT, _updated = param.updated, updated = _updated === void 0 ? "2022-12-12T19:57:40+00:00" : _updated, _published = param.published, published = _published === void 0 ? "2022-12-12T19:57:40+00:00" : _published, _modified = param.modified, modified = _modified === void 0 ? "2022-12-12T19:57:40+00:00" : _modified;
    var sentence = title.split(" ");
    for(var i = 0; i < sentence.length; i++){
        sentence[i] = sentence[i][0].toUpperCase() + sentence[i].slice(1);
    }
    var titleCaps = sentence.join(" ");
    var canonicalUrl = url ? "".concat(siteUrl, "/").concat(url.replace(/^\/+/, "")) // Remove leading slashes
     : siteUrl;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_3___default()), {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "robots",
                        content: "index, follow, max-snippet:-1, max-video-preview:-1, max-image-preview:large"
                    }),
                    "\\",
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "google-site-verification",
                        content: "B-43YtlLbhe_E2duJ5hogYutwdId35AX9ArCsxHsNvI"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:locale",
                        content: "en_GB"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:type",
                        content: "website"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("title", {
                        children: [
                            sitename,
                            " | ",
                            titleCaps
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "description",
                        content: description
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:title",
                        content: "".concat(sitename, " - ").concat(titleCaps)
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:site_name",
                        content: sitename
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:description",
                        content: description
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:image",
                        content: image
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:url",
                        content: "".concat(siteUrl, "/").concat(url)
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:updated_time",
                        content: updated
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "article:tag",
                        content: tag
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "article:publisher",
                        content: sitename
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "article:author",
                        content: author
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "article:published_time",
                        content: published
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "article:modified_time",
                        content: modified
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:url",
                        content: canonicalUrl
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                        rel: "canonical",
                        href: canonicalUrl
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:card",
                        content: "summary_large_image"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:title",
                        content: "".concat(sitename, " - ").concat(titleCaps)
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:description",
                        content: description
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:label1",
                        content: "Written by"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:data1",
                        content: author
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:label2",
                        content: "Time to read"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:data2",
                        content: "15 minutes"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                type: "application/ld+json",
                children: JSON.stringify({
                    "@context": "https://schema.org",
                    "@type": "WebPage",
                    "name": title,
                    "description": description,
                    "url": canonicalUrl
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_script__WEBPACK_IMPORTED_MODULE_2___default()), {
                id: "googletagmgr",
                async: true,
                src: "https://www.googletagmanager.com/gtag/js?id=G-NZ0FWDX3GT"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_script__WEBPACK_IMPORTED_MODULE_2___default()), {
                id: "googletagmgr2",
                dangerouslySetInnerHTML: {
                    __html: "(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':\n    new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],\n    j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=\n    'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);\n  })(window,document,'script','dataLayer','GTM-MMQM2XP');\n  \n \n  window.dataLayer = window.dataLayer || [];\n  function gtag(){dataLayer.push(arguments);}\n  gtag('js', new Date());\n\n  gtag('config', 'G-NZ0FWDX3GT');\n "
                }
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SEO);


/***/ }),

/***/ 50220:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

// ====================================================
var IconBox = function(param) {
    var icon = param.icon, className = param.className;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: className,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
            className: "uil ".concat(icon)
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (IconBox);


/***/ })

}]);